var Kr = Object.defineProperty;
var Hr = (e, t, r) => t in e ? Kr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Mt = (e, t, r) => Hr(e, typeof t != "symbol" ? t + "" : t, r);
import { nanoid as hr, formatProdErrorMessage as he, createAction as Re, createSelector as Wr, createNextState as Tt, createAsyncThunk as kt, createSlice as Ae, prepareAutoBatched as Pe, isAnyOf as Be, isFulfilled as me, isRejectedWithValue as Rt, combineReducers as Br, isPlainObject as De, SHOULD_AUTOBATCH as mr, isAllOf as it, isRejected as Pt, isPending as gr, isAction as Jr, isAsyncThunkAction as $t } from "@reduxjs/toolkit";
import { useStore as Gr, useSelector as Yr, useDispatch as Zr, batch as Xr, shallowEqual as Ce } from "react-redux";
import { useCallback as fe, useDebugValue as st, useMemo as Y, useState as xt, useEffect as de, useRef as le, useLayoutEffect as en } from "react";
var wt = Symbol.for("immer-nothing"), qe = Symbol.for("immer-draftable"), Z = Symbol.for("immer-state"), vr = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function H(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = vr[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var ge = Object.getPrototypeOf;
function ae(e) {
  return !!e && !!e[Z];
}
function ce(e) {
  var t;
  return e ? Er(e) || Array.isArray(e) || !!e[qe] || !!((t = e.constructor) != null && t[qe]) || xe(e) || Fe(e) : !1;
}
var tn = Object.prototype.constructor.toString();
function Er(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = ge(e);
  if (t === null)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === tn;
}
function rn(e) {
  return ae(e) || H(15, e), e[Z].base_;
}
function Le(e, t) {
  ve(e) === 0 ? Reflect.ownKeys(e).forEach((r) => {
    t(r, e[r], e);
  }) : e.forEach((r, n) => t(n, r, e));
}
function ve(e) {
  const t = e[Z];
  return t ? t.type_ : Array.isArray(e) ? 1 : xe(e) ? 2 : Fe(e) ? 3 : 0;
}
function Ne(e, t) {
  return ve(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function ot(e, t) {
  return ve(e) === 2 ? e.get(t) : e[t];
}
function Sr(e, t, r) {
  const n = ve(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function nn(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function xe(e) {
  return e instanceof Map;
}
function Fe(e) {
  return e instanceof Set;
}
function ye(e) {
  return e.copy_ || e.base_;
}
function ht(e, t) {
  if (xe(e))
    return new Map(e);
  if (Fe(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Er(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[Z];
    let i = Reflect.ownKeys(n);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], u = n[a];
      u.writable === !1 && (u.writable = !0, u.configurable = !0), (u.get || u.set) && (n[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: u.enumerable,
        value: e[a]
      });
    }
    return Object.create(ge(e), n);
  } else {
    const n = ge(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function Ot(e, t = !1) {
  return rt(e) || ae(e) || !ce(e) || (ve(e) > 1 && (e.set = e.add = e.clear = e.delete = sn), Object.freeze(e), t && Object.entries(e).forEach(([r, n]) => Ot(n, !0))), e;
}
function sn() {
  H(2);
}
function rt(e) {
  return Object.isFrozen(e);
}
var mt = {};
function Ee(e) {
  const t = mt[e];
  return t || H(0, e), t;
}
function on(e, t) {
  mt[e] || (mt[e] = t);
}
var Qe;
function _r() {
  return Qe;
}
function an(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Ft(e, t) {
  t && (Ee("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function gt(e) {
  vt(e), e.drafts_.forEach(cn), e.drafts_ = null;
}
function vt(e) {
  e === Qe && (Qe = e.parent_);
}
function zt(e) {
  return Qe = an(Qe, e);
}
function cn(e) {
  const t = e[Z];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function jt(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[Z].modified_ && (gt(t), H(4)), ce(e) && (e = Je(t, e), t.parent_ || Ge(t, e)), t.patches_ && Ee("Patches").generateReplacementPatches_(
    r[Z].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Je(t, r, []), gt(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== wt ? e : void 0;
}
function Je(e, t, r) {
  if (rt(t))
    return t;
  const n = t[Z];
  if (!n)
    return Le(
      t,
      (i, o) => Ut(e, n, t, i, o, r)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return Ge(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const i = n.copy_;
    let o = i, a = !1;
    n.type_ === 3 && (o = new Set(i), i.clear(), a = !0), Le(
      o,
      (u, w) => Ut(e, n, i, u, w, r, a)
    ), Ge(e, i, !1), r && e.patches_ && Ee("Patches").generatePatches_(
      n,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function Ut(e, t, r, n, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === r && H(5), ae(i)) {
    const u = o && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Ne(t.assigned_, n) ? o.concat(n) : void 0, w = Je(e, i, u);
    if (Sr(r, n, w), ae(w))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else a && r.add(i);
  if (ce(i) && !rt(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Je(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && Ge(e, i);
  }
}
function Ge(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Ot(t, r);
}
function un(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : _r(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, o = Ct;
  r && (i = [n], o = Me);
  const { revoke: a, proxy: u } = Proxy.revocable(i, o);
  return n.draft_ = u, n.revoke_ = a, u;
}
var Ct = {
  get(e, t) {
    if (t === Z)
      return e;
    const r = ye(e);
    if (!Ne(r, t))
      return ln(e, r, t);
    const n = r[t];
    return e.finalized_ || !ce(n) ? n : n === at(e.base_, t) ? (ct(e), e.copy_[t] = St(n, e)) : n;
  },
  has(e, t) {
    return t in ye(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ye(e));
  },
  set(e, t, r) {
    const n = br(ye(e), t);
    if (n != null && n.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = at(ye(e), t), o = i == null ? void 0 : i[Z];
      if (o && o.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (nn(r, i) && (r !== void 0 || Ne(e.base_, t)))
        return !0;
      ct(e), Et(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return at(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, ct(e), Et(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = ye(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    H(11);
  },
  getPrototypeOf(e) {
    return ge(e.base_);
  },
  setPrototypeOf() {
    H(12);
  }
}, Me = {};
Le(Ct, (e, t) => {
  Me[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Me.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && H(13), Me.set.call(this, e, t, void 0);
};
Me.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && H(14), Ct.set.call(this, e[0], t, r, e[0]);
};
function at(e, t) {
  const r = e[Z];
  return (r ? ye(r) : e)[t];
}
function ln(e, t, r) {
  var i;
  const n = br(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = n.get) == null ? void 0 : i.call(e.draft_)
  ) : void 0;
}
function br(e, t) {
  if (!(t in e))
    return;
  let r = ge(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = ge(r);
  }
}
function Et(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Et(e.parent_));
}
function ct(e) {
  e.copy_ || (e.copy_ = ht(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var dn = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const o = r;
        r = t;
        const a = this;
        return function(w = o, ...b) {
          return a.produce(w, (O) => r.call(this, O, ...b));
        };
      }
      typeof r != "function" && H(6), n !== void 0 && typeof n != "function" && H(7);
      let i;
      if (ce(t)) {
        const o = zt(this), a = St(t, void 0);
        let u = !0;
        try {
          i = r(a), u = !1;
        } finally {
          u ? gt(o) : vt(o);
        }
        return Ft(o, n), jt(i, o);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === wt && (i = void 0), this.autoFreeze_ && Ot(i, !0), n) {
          const o = [], a = [];
          Ee("Patches").generateReplacementPatches_(t, i, o, a), n(o, a);
        }
        return i;
      } else
        H(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (a, ...u) => this.produceWithPatches(a, (w) => t(w, ...u));
      let n, i;
      return [this.produce(t, r, (a, u) => {
        n = a, i = u;
      }), n, i];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    ce(e) || H(8), ae(e) && (e = fn(e));
    const t = zt(this), r = St(e, void 0);
    return r[Z].isManual_ = !0, vt(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[Z];
    (!r || !r.isManual_) && H(9);
    const { scope_: n } = r;
    return Ft(n, t), jt(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = Ee("Patches").applyPatches_;
    return ae(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function St(e, t) {
  const r = xe(e) ? Ee("MapSet").proxyMap_(e, t) : Fe(e) ? Ee("MapSet").proxySet_(e, t) : un(e, t);
  return (t ? t.scope_ : _r()).drafts_.push(r), r;
}
function fn(e) {
  return ae(e) || H(10, e), Ar(e);
}
function Ar(e) {
  if (!ce(e) || rt(e))
    return e;
  const t = e[Z];
  let r;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = ht(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    r = ht(e, !0);
  return Le(r, (n, i) => {
    Sr(r, n, Ar(i));
  }), t && (t.finalized_ = !1), r;
}
function pn() {
  process.env.NODE_ENV !== "production" && vr.push(
    'Sets cannot have "replace" patches.',
    function(l) {
      return "Unsupported patch operation: " + l;
    },
    function(l) {
      return "Cannot apply patch, path doesn't resolve: " + l;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const t = "replace", r = "add", n = "remove";
  function i(l, m, S, A) {
    switch (l.type_) {
      case 0:
      case 2:
        return a(
          l,
          m,
          S,
          A
        );
      case 1:
        return o(l, m, S, A);
      case 3:
        return u(
          l,
          m,
          S,
          A
        );
    }
  }
  function o(l, m, S, A) {
    let { base_: I, assigned_: v } = l, C = l.copy_;
    C.length < I.length && ([I, C] = [C, I], [S, A] = [A, S]);
    for (let p = 0; p < I.length; p++)
      if (v[p] && C[p] !== I[p]) {
        const s = m.concat([p]);
        S.push({
          op: t,
          path: s,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: R(C[p])
        }), A.push({
          op: t,
          path: s,
          value: R(I[p])
        });
      }
    for (let p = I.length; p < C.length; p++) {
      const s = m.concat([p]);
      S.push({
        op: r,
        path: s,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: R(C[p])
      });
    }
    for (let p = C.length - 1; I.length <= p; --p) {
      const s = m.concat([p]);
      A.push({
        op: n,
        path: s
      });
    }
  }
  function a(l, m, S, A) {
    const { base_: I, copy_: v } = l;
    Le(l.assigned_, (C, p) => {
      const s = ot(I, C), f = ot(v, C), P = p ? Ne(I, C) ? t : r : n;
      if (s === f && P === t)
        return;
      const _ = m.concat(C);
      S.push(P === n ? { op: P, path: _ } : { op: P, path: _, value: f }), A.push(
        P === r ? { op: n, path: _ } : P === n ? { op: r, path: _, value: R(s) } : { op: t, path: _, value: R(s) }
      );
    });
  }
  function u(l, m, S, A) {
    let { base_: I, copy_: v } = l, C = 0;
    I.forEach((p) => {
      if (!v.has(p)) {
        const s = m.concat([C]);
        S.push({
          op: n,
          path: s,
          value: p
        }), A.unshift({
          op: r,
          path: s,
          value: p
        });
      }
      C++;
    }), C = 0, v.forEach((p) => {
      if (!I.has(p)) {
        const s = m.concat([C]);
        S.push({
          op: r,
          path: s,
          value: p
        }), A.unshift({
          op: n,
          path: s,
          value: p
        });
      }
      C++;
    });
  }
  function w(l, m, S, A) {
    S.push({
      op: t,
      path: [],
      value: m === wt ? void 0 : m
    }), A.push({
      op: t,
      path: [],
      value: l
    });
  }
  function b(l, m) {
    return m.forEach((S) => {
      const { path: A, op: I } = S;
      let v = l;
      for (let f = 0; f < A.length - 1; f++) {
        const P = ve(v);
        let _ = A[f];
        typeof _ != "string" && typeof _ != "number" && (_ = "" + _), (P === 0 || P === 1) && (_ === "__proto__" || _ === "constructor") && H(19), typeof v == "function" && _ === "prototype" && H(19), v = ot(v, _), typeof v != "object" && H(18, A.join("/"));
      }
      const C = ve(v), p = O(S.value), s = A[A.length - 1];
      switch (I) {
        case t:
          switch (C) {
            case 2:
              return v.set(s, p);
            case 3:
              H(16);
            default:
              return v[s] = p;
          }
        case r:
          switch (C) {
            case 1:
              return s === "-" ? v.push(p) : v.splice(s, 0, p);
            case 2:
              return v.set(s, p);
            case 3:
              return v.add(p);
            default:
              return v[s] = p;
          }
        case n:
          switch (C) {
            case 1:
              return v.splice(s, 1);
            case 2:
              return v.delete(s);
            case 3:
              return v.delete(S.value);
            default:
              return delete v[s];
          }
        default:
          H(17, I);
      }
    }), l;
  }
  function O(l) {
    if (!ce(l))
      return l;
    if (Array.isArray(l))
      return l.map(O);
    if (xe(l))
      return new Map(
        Array.from(l.entries()).map(([S, A]) => [S, O(A)])
      );
    if (Fe(l))
      return new Set(Array.from(l).map(O));
    const m = Object.create(ge(l));
    for (const S in l)
      m[S] = O(l[S]);
    return Ne(l, qe) && (m[qe] = l[qe]), m;
  }
  function R(l) {
    return ae(l) ? O(l) : l;
  }
  on("Patches", {
    applyPatches_: b,
    generatePatches_: i,
    generateReplacementPatches_: w
  });
}
var X = new dn();
X.produce;
var Ir = X.produceWithPatches.bind(
  X
);
X.setAutoFreeze.bind(X);
X.setUseStrictShallowCopy.bind(X);
var Vt = X.applyPatches.bind(X);
X.createDraft.bind(X);
X.finishDraft.bind(X);
var yn = class extends Error {
  /**
   * Creates a schema error with useful information.
   *
   * @param issues The schema issues.
   */
  constructor(t) {
    super(t[0].message);
    /**
     * The schema issues.
     */
    Mt(this, "issues");
    this.name = "SchemaError", this.issues = t;
  }
}, hn = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (o) {
        ({ stack: i } = o);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, mn = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: o, inputSelectorResultsCopy: a } = e, u = n(() => ({}), ...i);
  if (!(u.apply(null, o) === u.apply(null, a))) {
    let b;
    try {
      throw new Error();
    } catch (O) {
      ({ stack: b } = O);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: o,
        secondInputs: a,
        stack: b
      }
    );
  }
}, gn = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function vn(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function En(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Sn(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var Kt = (e) => Array.isArray(e) ? e : [e];
function _n(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Sn(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function Ht(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var bn = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...gn,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: hn
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: mn
    }
  };
}, An = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, In = typeof WeakRef < "u" ? WeakRef : An, Tn = 0, Wt = 1;
function je() {
  return {
    s: Tn,
    v: void 0,
    o: null,
    p: null
  };
}
function Ye(e, t = {}) {
  let r = je();
  const { resultEqualityCheck: n } = t;
  let i, o = 0;
  function a() {
    var R;
    let u = r;
    const { length: w } = arguments;
    for (let l = 0, m = w; l < m; l++) {
      const S = arguments[l];
      if (typeof S == "function" || typeof S == "object" && S !== null) {
        let A = u.o;
        A === null && (u.o = A = /* @__PURE__ */ new WeakMap());
        const I = A.get(S);
        I === void 0 ? (u = je(), A.set(S, u)) : u = I;
      } else {
        let A = u.p;
        A === null && (u.p = A = /* @__PURE__ */ new Map());
        const I = A.get(S);
        I === void 0 ? (u = je(), A.set(S, u)) : u = I;
      }
    }
    const b = u;
    let O;
    if (u.s === Wt)
      O = u.v;
    else if (O = e.apply(null, arguments), o++, n) {
      const l = ((R = i == null ? void 0 : i.deref) == null ? void 0 : R.call(i)) ?? i;
      l != null && n(l, O) && (O = l, o !== 0 && o--), i = typeof O == "object" && O !== null || typeof O == "function" ? new In(O) : O;
    }
    return b.s = Wt, b.v = O, O;
  }
  return a.clearCache = () => {
    r = je(), a.resetResultsCount();
  }, a.resultsCount = () => o, a.resetResultsCount = () => {
    o = 0;
  }, a;
}
function Rn(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let o = 0, a = 0, u, w = {}, b = i.pop();
    typeof b == "object" && (w = b, b = i.pop()), vn(
      b,
      `createSelector expects an output function after the inputs, but received: [${typeof b}]`
    );
    const O = {
      ...r,
      ...w
    }, {
      memoize: R,
      memoizeOptions: l = [],
      argsMemoize: m = Ye,
      argsMemoizeOptions: S = [],
      devModeChecks: A = {}
    } = O, I = Kt(l), v = Kt(S), C = _n(i), p = R(function() {
      return o++, b.apply(
        null,
        arguments
      );
    }, ...I);
    let s = !0;
    const f = m(function() {
      a++;
      const _ = Ht(
        C,
        arguments
      );
      if (u = p.apply(null, _), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: T, inputStabilityCheck: g } = bn(s, A);
        if (T.shouldRun && T.run(
          b,
          _,
          u
        ), g.shouldRun) {
          const d = Ht(
            C,
            arguments
          );
          g.run(
            { inputSelectorResults: _, inputSelectorResultsCopy: d },
            { memoize: R, memoizeOptions: I },
            arguments
          );
        }
        s && (s = !1);
      }
      return u;
    }, ...v);
    return Object.assign(f, {
      resultFunc: b,
      memoizedResultFunc: p,
      dependencies: C,
      dependencyRecomputations: () => a,
      resetDependencyRecomputations: () => {
        a = 0;
      },
      lastResult: () => u,
      recomputations: () => o,
      resetRecomputations: () => {
        o = 0;
      },
      memoize: R,
      argsMemoize: m
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Tr = /* @__PURE__ */ Rn(Ye), Pn = Object.assign(
  (e, t = Tr) => {
    En(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (o) => e[o]
    );
    return t(
      n,
      (...o) => o.reduce((a, u, w) => (a[r[w]] = u, a), {})
    );
  },
  { withTypes: () => Pn }
), Rr = /* @__PURE__ */ ((e) => (e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected", e))(Rr || {});
function Bt(e) {
  return {
    status: e,
    isUninitialized: e === "uninitialized",
    isLoading: e === "pending",
    isSuccess: e === "fulfilled",
    isError: e === "rejected"
    /* rejected */
  };
}
var Jt = De;
function Pr(e, t) {
  if (e === t || !(Jt(e) && Jt(t) || Array.isArray(e) && Array.isArray(t)))
    return t;
  const r = Object.keys(t), n = Object.keys(e);
  let i = r.length === n.length;
  const o = Array.isArray(t) ? [] : {};
  for (const a of r)
    o[a] = Pr(e[a], t[a]), i && (i = e[a] === o[a]);
  return i ? e : o;
}
function Te(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
var Gt = (e) => [].concat(...e);
function wn() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
function Ze(e) {
  return e != null;
}
function On() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function Cn(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r).get(t);
}
var Yt = class {
  constructor(e, t = void 0) {
    this.value = e, this.meta = t;
  }
}, qt = /* @__PURE__ */ Re("__rtkq/focused"), wr = /* @__PURE__ */ Re("__rtkq/unfocused"), Dt = /* @__PURE__ */ Re("__rtkq/online"), Or = /* @__PURE__ */ Re("__rtkq/offline");
function nt(e) {
  return e.type === "query";
}
function qn(e) {
  return e.type === "mutation";
}
function ze(e) {
  return e.type === "infinitequery";
}
function Xe(e) {
  return nt(e) || ze(e);
}
function Lt(e, t, r, n, i, o) {
  return Dn(e) ? e(t, r, n, i).filter(Ze).map(_t).map(o) : Array.isArray(e) ? e.map(_t).map(o) : [];
}
function Dn(e) {
  return typeof e == "function";
}
function _t(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function Ln(e, t) {
  return e.catch(t);
}
var ke = Symbol("forceQueryFn"), bt = (e) => typeof e[ke] == "function";
function Nn({
  serializeQueryArgs: e,
  queryThunk: t,
  infiniteQueryThunk: r,
  mutationThunk: n,
  api: i,
  context: o
}) {
  const a = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), {
    unsubscribeQueryResult: w,
    removeMutationResult: b,
    updateSubscriptionOptions: O
  } = i.internalActions;
  return {
    buildInitiateQuery: v,
    buildInitiateInfiniteQuery: C,
    buildInitiateMutation: p,
    getRunningQueryThunk: R,
    getRunningMutationThunk: l,
    getRunningQueriesThunk: m,
    getRunningMutationsThunk: S
  };
  function R(s, f) {
    return (P) => {
      var g;
      const _ = o.endpointDefinitions[s], T = e({
        queryArgs: f,
        endpointDefinition: _,
        endpointName: s
      });
      return (g = a.get(P)) == null ? void 0 : g[T];
    };
  }
  function l(s, f) {
    return (P) => {
      var _;
      return (_ = u.get(P)) == null ? void 0 : _[f];
    };
  }
  function m() {
    return (s) => Object.values(a.get(s) || {}).filter(Ze);
  }
  function S() {
    return (s) => Object.values(u.get(s) || {}).filter(Ze);
  }
  function A(s) {
    if (process.env.NODE_ENV !== "production") {
      if (A.triggered) return;
      const f = s(i.internalActions.internal_getRTKQSubscriptions());
      if (A.triggered = !0, typeof f != "object" || typeof (f == null ? void 0 : f.type) == "string")
        throw new Error(process.env.NODE_ENV === "production" ? he(34) : `Warning: Middleware for RTK-Query API at reducerPath "${i.reducerPath}" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function I(s, f) {
    const P = (_, {
      subscribe: T = !0,
      forceRefetch: g,
      subscriptionOptions: d,
      [ke]: c,
      ...h
    } = {}) => (y, E) => {
      var K;
      const q = e({
        queryArgs: _,
        endpointDefinition: f,
        endpointName: s
      });
      let N;
      const L = {
        ...h,
        type: "query",
        subscribe: T,
        forceRefetch: g,
        subscriptionOptions: d,
        endpointName: s,
        originalArgs: _,
        queryCacheKey: q,
        [ke]: c
      };
      if (nt(f))
        N = t(L);
      else {
        const {
          direction: j,
          initialPageParam: ee
        } = h;
        N = r({
          ...L,
          // Supply these even if undefined. This helps with a field existence
          // check over in `buildSlice.ts`
          direction: j,
          initialPageParam: ee
        });
      }
      const M = i.endpoints[s].select(_), Q = y(N), $ = M(E());
      A(y);
      const {
        requestId: x,
        abort: U
      } = Q, W = $.requestId !== x, B = (K = a.get(y)) == null ? void 0 : K[q], k = () => M(E()), z = Object.assign(c ? (
        // a query has been forced (upsertQueryData)
        // -> we want to resolve it once data has been written with the data that will be written
        Q.then(k)
      ) : W && !B ? (
        // a query has been skipped due to a condition and we do not have any currently running query
        // -> we want to resolve it immediately with the current data
        Promise.resolve($)
      ) : (
        // query just started or one is already in flight
        // -> wait for the running query, then resolve with data from after that
        Promise.all([B, Q]).then(k)
      ), {
        arg: _,
        requestId: x,
        subscriptionOptions: d,
        queryCacheKey: q,
        abort: U,
        async unwrap() {
          const j = await z;
          if (j.isError)
            throw j.error;
          return j.data;
        },
        refetch: () => y(P(_, {
          subscribe: !1,
          forceRefetch: !0
        })),
        unsubscribe() {
          T && y(w({
            queryCacheKey: q,
            requestId: x
          }));
        },
        updateSubscriptionOptions(j) {
          z.subscriptionOptions = j, y(O({
            endpointName: s,
            requestId: x,
            queryCacheKey: q,
            options: j
          }));
        }
      });
      if (!B && !W && !c) {
        const j = Cn(a, y, {});
        j[q] = z, z.then(() => {
          delete j[q], Te(j) || a.delete(y);
        });
      }
      return z;
    };
    return P;
  }
  function v(s, f) {
    return I(s, f);
  }
  function C(s, f) {
    return I(s, f);
  }
  function p(s) {
    return (f, {
      track: P = !0,
      fixedCacheKey: _
    } = {}) => (T, g) => {
      const d = n({
        type: "mutation",
        endpointName: s,
        originalArgs: f,
        track: P,
        fixedCacheKey: _
      }), c = T(d);
      A(T);
      const {
        requestId: h,
        abort: y,
        unwrap: E
      } = c, q = Ln(c.unwrap().then((Q) => ({
        data: Q
      })), (Q) => ({
        error: Q
      })), N = () => {
        T(b({
          requestId: h,
          fixedCacheKey: _
        }));
      }, L = Object.assign(q, {
        arg: c.arg,
        requestId: h,
        abort: y,
        unwrap: E,
        reset: N
      }), M = u.get(T) || {};
      return u.set(T, M), M[h] = L, L.then(() => {
        delete M[h], Te(M) || u.delete(T);
      }), _ && (M[_] = L, L.then(() => {
        M[_] === L && (delete M[_], Te(M) || u.delete(T));
      })), L;
    };
  }
}
var Cr = class extends yn {
  constructor(e, t, r, n) {
    super(e), this.value = t, this.schemaName = r, this._bqMeta = n;
  }
};
async function pe(e, t, r, n) {
  const i = await e["~standard"].validate(t);
  if (i.issues)
    throw new Cr(i.issues, t, r, n);
  return i.value;
}
function Qn(e) {
  return e;
}
var we = (e = {}) => ({
  ...e,
  [mr]: !0
});
function Mn({
  reducerPath: e,
  baseQuery: t,
  context: {
    endpointDefinitions: r
  },
  serializeQueryArgs: n,
  api: i,
  assertTagType: o,
  selectors: a,
  onSchemaFailure: u,
  catchSchemaFailure: w,
  skipSchemaValidation: b
}) {
  const O = (c, h, y, E) => (q, N) => {
    const L = r[c], M = n({
      queryArgs: h,
      endpointDefinition: L,
      endpointName: c
    });
    if (q(i.internalActions.queryResultPatched({
      queryCacheKey: M,
      patches: y
    })), !E)
      return;
    const Q = i.endpoints[c].select(h)(
      // Work around TS 4.1 mismatch
      N()
    ), $ = Lt(L.providesTags, Q.data, void 0, h, {}, o);
    q(i.internalActions.updateProvidedBy([{
      queryCacheKey: M,
      providedTags: $
    }]));
  };
  function R(c, h, y = 0) {
    const E = [h, ...c];
    return y && E.length > y ? E.slice(0, -1) : E;
  }
  function l(c, h, y = 0) {
    const E = [...c, h];
    return y && E.length > y ? E.slice(1) : E;
  }
  const m = (c, h, y, E = !0) => (q, N) => {
    const M = i.endpoints[c].select(h)(
      // Work around TS 4.1 mismatch
      N()
    ), Q = {
      patches: [],
      inversePatches: [],
      undo: () => q(i.util.patchQueryData(c, h, Q.inversePatches, E))
    };
    if (M.status === "uninitialized")
      return Q;
    let $;
    if ("data" in M)
      if (ce(M.data)) {
        const [x, U, W] = Ir(M.data, y);
        Q.patches.push(...U), Q.inversePatches.push(...W), $ = x;
      } else
        $ = y(M.data), Q.patches.push({
          op: "replace",
          path: [],
          value: $
        }), Q.inversePatches.push({
          op: "replace",
          path: [],
          value: M.data
        });
    return Q.patches.length === 0 || q(i.util.patchQueryData(c, h, Q.patches, E)), Q;
  }, S = (c, h, y) => (E) => E(i.endpoints[c].initiate(h, {
    subscribe: !1,
    forceRefetch: !0,
    [ke]: () => ({
      data: y
    })
  })), A = (c, h) => c.query && c[h] ? c[h] : Qn, I = async (c, {
    signal: h,
    abort: y,
    rejectWithValue: E,
    fulfillWithValue: q,
    dispatch: N,
    getState: L,
    extra: M
  }) => {
    var U, W;
    const Q = r[c.endpointName], {
      metaSchema: $,
      skipSchemaValidation: x = b
    } = Q;
    try {
      let B = A(Q, "transformResponse");
      const k = {
        signal: h,
        abort: y,
        dispatch: N,
        getState: L,
        extra: M,
        endpoint: c.endpointName,
        type: c.type,
        forced: c.type === "query" ? v(c, L()) : void 0,
        queryCacheKey: c.type === "query" ? c.queryCacheKey : void 0
      }, z = c.type === "query" ? c[ke] : void 0;
      let K;
      const j = async (V, F, J, Se) => {
        if (F == null && V.pages.length)
          return Promise.resolve({
            data: V
          });
        const ie = {
          queryArg: c.originalArgs,
          pageParam: F
        }, _e = await ee(ie), se = Se ? R : l;
        return {
          data: {
            pages: se(V.pages, _e.data, J),
            pageParams: se(V.pageParams, F, J)
          },
          meta: _e.meta
        };
      };
      async function ee(V) {
        let F;
        const {
          extraOptions: J,
          argSchema: Se,
          rawResponseSchema: ie,
          responseSchema: _e
        } = Q;
        if (Se && !x && (V = await pe(
          Se,
          V,
          "argSchema",
          {}
          // we don't have a meta yet, so we can't pass it
        )), z ? F = z() : Q.query ? F = await t(Q.query(V), k, J) : F = await Q.queryFn(V, k, J, (te) => t(te, k, J)), typeof process < "u" && process.env.NODE_ENV === "development") {
          const te = Q.query ? "`baseQuery`" : "`queryFn`";
          let re;
          if (!F)
            re = `${te} did not return anything.`;
          else if (typeof F != "object")
            re = `${te} did not return an object.`;
          else if (F.error && F.data)
            re = `${te} returned an object containing both \`error\` and \`result\`.`;
          else if (F.error === void 0 && F.data === void 0)
            re = `${te} returned an object containing neither a valid \`error\` and \`result\`. At least one of them should not be \`undefined\``;
          else
            for (const be of Object.keys(F))
              if (be !== "error" && be !== "data" && be !== "meta") {
                re = `The object returned by ${te} has the unknown property ${be}.`;
                break;
              }
          re && console.error(`Error encountered handling the endpoint ${c.endpointName}.
                  ${re}
                  It needs to return an object with either the shape \`{ data: <value> }\` or \`{ error: <value> }\` that may contain an optional \`meta\` property.
                  Object returned was:`, F);
        }
        if (F.error) throw new Yt(F.error, F.meta);
        let {
          data: se
        } = F;
        ie && !x && (se = await pe(ie, F.data, "rawResponseSchema", F.meta));
        let ue = await B(se, F.meta, V);
        return _e && !x && (ue = await pe(_e, ue, "responseSchema", F.meta)), {
          ...F,
          data: ue
        };
      }
      if (c.type === "query" && "infiniteQueryOptions" in Q) {
        const {
          infiniteQueryOptions: V
        } = Q, {
          maxPages: F = 1 / 0
        } = V;
        let J;
        const Se = {
          pages: [],
          pageParams: []
        }, ie = (U = a.selectQueryEntry(L(), c.queryCacheKey)) == null ? void 0 : U.data, se = /* arg.forceRefetch */ v(c, L()) && !c.direction || !ie ? Se : ie;
        if ("direction" in c && c.direction && se.pages.length) {
          const ue = c.direction === "backward", re = (ue ? qr : At)(V, se, c.originalArgs);
          J = await j(se, re, F, ue);
        } else {
          const {
            initialPageParam: ue = V.initialPageParam
          } = c, te = (ie == null ? void 0 : ie.pageParams) ?? [], re = te[0] ?? ue, be = te.length;
          J = await j(se, re, F), z && (J = {
            data: J.data.pages[0]
          });
          for (let Qt = 1; Qt < be; Qt++) {
            const Vr = At(V, J.data, c.originalArgs);
            J = await j(J.data, Vr, F);
          }
        }
        K = J;
      } else
        K = await ee(c.originalArgs);
      return $ && !x && K.meta && (K.meta = await pe($, K.meta, "metaSchema", K.meta)), q(K.data, we({
        fulfilledTimeStamp: Date.now(),
        baseQueryMeta: K.meta
      }));
    } catch (B) {
      let k = B;
      if (k instanceof Yt) {
        let z = A(Q, "transformErrorResponse");
        const {
          rawErrorResponseSchema: K,
          errorResponseSchema: j
        } = Q;
        let {
          value: ee,
          meta: V
        } = k;
        try {
          K && !x && (ee = await pe(K, ee, "rawErrorResponseSchema", V)), $ && !x && (V = await pe($, V, "metaSchema", V));
          let F = await z(ee, V, c.originalArgs);
          return j && !x && (F = await pe(j, F, "errorResponseSchema", V)), E(F, we({
            baseQueryMeta: V
          }));
        } catch (F) {
          k = F;
        }
      }
      try {
        if (k instanceof Cr) {
          const z = {
            endpoint: c.endpointName,
            arg: c.originalArgs,
            type: c.type,
            queryCacheKey: c.type === "query" ? c.queryCacheKey : void 0
          };
          (W = Q.onSchemaFailure) == null || W.call(Q, k, z), u == null || u(k, z);
          const {
            catchSchemaFailure: K = w
          } = Q;
          if (K)
            return E(K(k, z), we({
              baseQueryMeta: k._bqMeta
            }));
        }
      } catch (z) {
        k = z;
      }
      throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error(`An unhandled error occurred processing a request for the endpoint "${c.endpointName}".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, k) : console.error(k), k;
    }
  };
  function v(c, h) {
    const y = a.selectQueryEntry(h, c.queryCacheKey), E = a.selectConfig(h).refetchOnMountOrArgChange, q = y == null ? void 0 : y.fulfilledTimeStamp, N = c.forceRefetch ?? (c.subscribe && E);
    return N ? N === !0 || (Number(/* @__PURE__ */ new Date()) - Number(q)) / 1e3 >= N : !1;
  }
  const C = () => kt(`${e}/executeQuery`, I, {
    getPendingMeta({
      arg: h
    }) {
      const y = r[h.endpointName];
      return we({
        startedTimeStamp: Date.now(),
        ...ze(y) ? {
          direction: h.direction
        } : {}
      });
    },
    condition(h, {
      getState: y
    }) {
      var x;
      const E = y(), q = a.selectQueryEntry(E, h.queryCacheKey), N = q == null ? void 0 : q.fulfilledTimeStamp, L = h.originalArgs, M = q == null ? void 0 : q.originalArgs, Q = r[h.endpointName], $ = h.direction;
      return bt(h) ? !0 : (q == null ? void 0 : q.status) === "pending" ? !1 : v(h, E) || nt(Q) && ((x = Q == null ? void 0 : Q.forceRefetch) != null && x.call(Q, {
        currentArg: L,
        previousArg: M,
        endpointState: q,
        state: E
      })) ? !0 : !(N && !$);
    },
    dispatchConditionRejection: !0
  }), p = C(), s = C(), f = kt(`${e}/executeMutation`, I, {
    getPendingMeta() {
      return we({
        startedTimeStamp: Date.now()
      });
    }
  }), P = (c) => "force" in c, _ = (c) => "ifOlderThan" in c, T = (c, h, y) => (E, q) => {
    const N = P(y) && y.force, L = _(y) && y.ifOlderThan, M = ($ = !0) => {
      const x = {
        forceRefetch: $,
        isPrefetch: !0
      };
      return i.endpoints[c].initiate(h, x);
    }, Q = i.endpoints[c].select(h)(q());
    if (N)
      E(M());
    else if (L) {
      const $ = Q == null ? void 0 : Q.fulfilledTimeStamp;
      if (!$) {
        E(M());
        return;
      }
      (Number(/* @__PURE__ */ new Date()) - Number(new Date($))) / 1e3 >= L && E(M());
    } else
      E(M(!1));
  };
  function g(c) {
    return (h) => {
      var y, E;
      return ((E = (y = h == null ? void 0 : h.meta) == null ? void 0 : y.arg) == null ? void 0 : E.endpointName) === c;
    };
  }
  function d(c, h) {
    return {
      matchPending: it(gr(c), g(h)),
      matchFulfilled: it(me(c), g(h)),
      matchRejected: it(Pt(c), g(h))
    };
  }
  return {
    queryThunk: p,
    mutationThunk: f,
    infiniteQueryThunk: s,
    prefetch: T,
    updateQueryData: m,
    upsertQueryData: S,
    patchQueryData: O,
    buildMatchThunkActions: d
  };
}
function At(e, {
  pages: t,
  pageParams: r
}, n) {
  const i = t.length - 1;
  return e.getNextPageParam(t[i], t, r[i], r, n);
}
function qr(e, {
  pages: t,
  pageParams: r
}, n) {
  var i;
  return (i = e.getPreviousPageParam) == null ? void 0 : i.call(e, t[0], t, r[0], r, n);
}
function Dr(e, t, r, n) {
  return Lt(r[e.meta.arg.endpointName][t], me(e) ? e.payload : void 0, Rt(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, n);
}
function Ue(e, t, r) {
  const n = e[t];
  n && r(n);
}
function $e(e) {
  return ("arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) ?? e.requestId;
}
function Zt(e, t, r) {
  const n = e[$e(t)];
  n && r(n);
}
var Ve = {};
function kn({
  reducerPath: e,
  queryThunk: t,
  mutationThunk: r,
  serializeQueryArgs: n,
  context: {
    endpointDefinitions: i,
    apiUid: o,
    extractRehydrationInfo: a,
    hasRehydrationInfo: u
  },
  assertTagType: w,
  config: b
}) {
  const O = Re(`${e}/resetApiState`);
  function R(g, d, c, h) {
    var y;
    g[y = d.queryCacheKey] ?? (g[y] = {
      status: "uninitialized",
      endpointName: d.endpointName
    }), Ue(g, d.queryCacheKey, (E) => {
      E.status = "pending", E.requestId = c && E.requestId ? (
        // for `upsertQuery` **updates**, keep the current `requestId`
        E.requestId
      ) : (
        // for normal queries or `upsertQuery` **inserts** always update the `requestId`
        h.requestId
      ), d.originalArgs !== void 0 && (E.originalArgs = d.originalArgs), E.startedTimeStamp = h.startedTimeStamp;
      const q = i[h.arg.endpointName];
      ze(q) && "direction" in d && (E.direction = d.direction);
    });
  }
  function l(g, d, c, h) {
    Ue(g, d.arg.queryCacheKey, (y) => {
      if (y.requestId !== d.requestId && !h) return;
      const {
        merge: E
      } = i[d.arg.endpointName];
      if (y.status = "fulfilled", E)
        if (y.data !== void 0) {
          const {
            fulfilledTimeStamp: q,
            arg: N,
            baseQueryMeta: L,
            requestId: M
          } = d;
          let Q = Tt(y.data, ($) => E($, c, {
            arg: N.originalArgs,
            baseQueryMeta: L,
            fulfilledTimeStamp: q,
            requestId: M
          }));
          y.data = Q;
        } else
          y.data = c;
      else
        y.data = i[d.arg.endpointName].structuralSharing ?? !0 ? Pr(ae(y.data) ? rn(y.data) : y.data, c) : c;
      delete y.error, y.fulfilledTimeStamp = d.fulfilledTimeStamp;
    });
  }
  const m = Ae({
    name: `${e}/queries`,
    initialState: Ve,
    reducers: {
      removeQueryResult: {
        reducer(g, {
          payload: {
            queryCacheKey: d
          }
        }) {
          delete g[d];
        },
        prepare: Pe()
      },
      cacheEntriesUpserted: {
        reducer(g, d) {
          for (const c of d.payload) {
            const {
              queryDescription: h,
              value: y
            } = c;
            R(g, h, !0, {
              arg: h,
              requestId: d.meta.requestId,
              startedTimeStamp: d.meta.timestamp
            }), l(
              g,
              {
                arg: h,
                requestId: d.meta.requestId,
                fulfilledTimeStamp: d.meta.timestamp,
                baseQueryMeta: {}
              },
              y,
              // We know we're upserting here
              !0
            );
          }
        },
        prepare: (g) => ({
          payload: g.map((h) => {
            const {
              endpointName: y,
              arg: E,
              value: q
            } = h, N = i[y];
            return {
              queryDescription: {
                type: "query",
                endpointName: y,
                originalArgs: h.arg,
                queryCacheKey: n({
                  queryArgs: E,
                  endpointDefinition: N,
                  endpointName: y
                })
              },
              value: q
            };
          }),
          meta: {
            [mr]: !0,
            requestId: hr(),
            timestamp: Date.now()
          }
        })
      },
      queryResultPatched: {
        reducer(g, {
          payload: {
            queryCacheKey: d,
            patches: c
          }
        }) {
          Ue(g, d, (h) => {
            h.data = Vt(h.data, c.concat());
          });
        },
        prepare: Pe()
      }
    },
    extraReducers(g) {
      g.addCase(t.pending, (d, {
        meta: c,
        meta: {
          arg: h
        }
      }) => {
        const y = bt(h);
        R(d, h, y, c);
      }).addCase(t.fulfilled, (d, {
        meta: c,
        payload: h
      }) => {
        const y = bt(c.arg);
        l(d, c, h, y);
      }).addCase(t.rejected, (d, {
        meta: {
          condition: c,
          arg: h,
          requestId: y
        },
        error: E,
        payload: q
      }) => {
        Ue(d, h.queryCacheKey, (N) => {
          if (!c) {
            if (N.requestId !== y) return;
            N.status = "rejected", N.error = q ?? E;
          }
        });
      }).addMatcher(u, (d, c) => {
        const {
          queries: h
        } = a(c);
        for (const [y, E] of Object.entries(h))
          // do not rehydrate entries that were currently in flight.
          ((E == null ? void 0 : E.status) === "fulfilled" || (E == null ? void 0 : E.status) === "rejected") && (d[y] = E);
      });
    }
  }), S = Ae({
    name: `${e}/mutations`,
    initialState: Ve,
    reducers: {
      removeMutationResult: {
        reducer(g, {
          payload: d
        }) {
          const c = $e(d);
          c in g && delete g[c];
        },
        prepare: Pe()
      }
    },
    extraReducers(g) {
      g.addCase(r.pending, (d, {
        meta: c,
        meta: {
          requestId: h,
          arg: y,
          startedTimeStamp: E
        }
      }) => {
        y.track && (d[$e(c)] = {
          requestId: h,
          status: "pending",
          endpointName: y.endpointName,
          startedTimeStamp: E
        });
      }).addCase(r.fulfilled, (d, {
        payload: c,
        meta: h
      }) => {
        h.arg.track && Zt(d, h, (y) => {
          y.requestId === h.requestId && (y.status = "fulfilled", y.data = c, y.fulfilledTimeStamp = h.fulfilledTimeStamp);
        });
      }).addCase(r.rejected, (d, {
        payload: c,
        error: h,
        meta: y
      }) => {
        y.arg.track && Zt(d, y, (E) => {
          E.requestId === y.requestId && (E.status = "rejected", E.error = c ?? h);
        });
      }).addMatcher(u, (d, c) => {
        const {
          mutations: h
        } = a(c);
        for (const [y, E] of Object.entries(h))
          // do not rehydrate entries that were currently in flight.
          ((E == null ? void 0 : E.status) === "fulfilled" || (E == null ? void 0 : E.status) === "rejected") && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
          y !== (E == null ? void 0 : E.requestId) && (d[y] = E);
      });
    }
  }), A = {
    tags: {},
    keys: {}
  }, I = Ae({
    name: `${e}/invalidation`,
    initialState: A,
    reducers: {
      updateProvidedBy: {
        reducer(g, d) {
          var c, h, y;
          for (const {
            queryCacheKey: E,
            providedTags: q
          } of d.payload) {
            v(g, E);
            for (const {
              type: N,
              id: L
            } of q) {
              const M = (h = (c = g.tags)[N] ?? (c[N] = {}))[y = L || "__internal_without_id"] ?? (h[y] = []);
              M.includes(E) || M.push(E);
            }
            g.keys[E] = q;
          }
        },
        prepare: Pe()
      }
    },
    extraReducers(g) {
      g.addCase(m.actions.removeQueryResult, (d, {
        payload: {
          queryCacheKey: c
        }
      }) => {
        v(d, c);
      }).addMatcher(u, (d, c) => {
        var y, E, q;
        const {
          provided: h
        } = a(c);
        for (const [N, L] of Object.entries(h))
          for (const [M, Q] of Object.entries(L)) {
            const $ = (E = (y = d.tags)[N] ?? (y[N] = {}))[q = M || "__internal_without_id"] ?? (E[q] = []);
            for (const x of Q)
              $.includes(x) || $.push(x);
          }
      }).addMatcher(Be(me(t), Rt(t)), (d, c) => {
        C(d, [c]);
      }).addMatcher(m.actions.cacheEntriesUpserted.match, (d, c) => {
        const h = c.payload.map(({
          queryDescription: y,
          value: E
        }) => ({
          type: "UNKNOWN",
          payload: E,
          meta: {
            requestStatus: "fulfilled",
            requestId: "UNKNOWN",
            arg: y
          }
        }));
        C(d, h);
      });
    }
  });
  function v(g, d) {
    var h;
    const c = g.keys[d] ?? [];
    for (const y of c) {
      const E = y.type, q = y.id ?? "__internal_without_id", N = (h = g.tags[E]) == null ? void 0 : h[q];
      N && (g.tags[E][q] = N.filter((L) => L !== d));
    }
    delete g.keys[d];
  }
  function C(g, d) {
    const c = d.map((h) => {
      const y = Dr(h, "providesTags", i, w), {
        queryCacheKey: E
      } = h.meta.arg;
      return {
        queryCacheKey: E,
        providedTags: y
      };
    });
    I.caseReducers.updateProvidedBy(g, I.actions.updateProvidedBy(c));
  }
  const p = Ae({
    name: `${e}/subscriptions`,
    initialState: Ve,
    reducers: {
      updateSubscriptionOptions(g, d) {
      },
      unsubscribeQueryResult(g, d) {
      },
      internal_getRTKQSubscriptions() {
      }
    }
  }), s = Ae({
    name: `${e}/internalSubscriptions`,
    initialState: Ve,
    reducers: {
      subscriptionsUpdated: {
        reducer(g, d) {
          return Vt(g, d.payload);
        },
        prepare: Pe()
      }
    }
  }), f = Ae({
    name: `${e}/config`,
    initialState: {
      online: On(),
      focused: wn(),
      middlewareRegistered: !1,
      ...b
    },
    reducers: {
      middlewareRegistered(g, {
        payload: d
      }) {
        g.middlewareRegistered = g.middlewareRegistered === "conflict" || o !== d ? "conflict" : !0;
      }
    },
    extraReducers: (g) => {
      g.addCase(Dt, (d) => {
        d.online = !0;
      }).addCase(Or, (d) => {
        d.online = !1;
      }).addCase(qt, (d) => {
        d.focused = !0;
      }).addCase(wr, (d) => {
        d.focused = !1;
      }).addMatcher(u, (d) => ({
        ...d
      }));
    }
  }), P = Br({
    queries: m.reducer,
    mutations: S.reducer,
    provided: I.reducer,
    subscriptions: s.reducer,
    config: f.reducer
  }), _ = (g, d) => P(O.match(d) ? void 0 : g, d), T = {
    ...f.actions,
    ...m.actions,
    ...p.actions,
    ...s.actions,
    ...S.actions,
    ...I.actions,
    resetApiState: O
  };
  return {
    reducer: _,
    actions: T
  };
}
var ne = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), Lr = {
  status: "uninitialized"
  /* uninitialized */
}, Xt = /* @__PURE__ */ Tt(Lr, () => {
}), er = /* @__PURE__ */ Tt(Lr, () => {
});
function $n({
  serializeQueryArgs: e,
  reducerPath: t,
  createSelector: r
}) {
  const n = (p) => Xt, i = (p) => er;
  return {
    buildQuerySelector: l,
    buildInfiniteQuerySelector: m,
    buildMutationSelector: S,
    selectInvalidatedBy: A,
    selectCachedArgsForQuery: I,
    selectApiState: a,
    selectQueries: u,
    selectMutations: b,
    selectQueryEntry: w,
    selectConfig: O
  };
  function o(p) {
    return {
      ...p,
      ...Bt(p.status)
    };
  }
  function a(p) {
    const s = p[t];
    if (process.env.NODE_ENV !== "production" && !s) {
      if (a.triggered) return s;
      a.triggered = !0, console.error(`Error: No data found at \`state.${t}\`. Did you forget to add the reducer to the store?`);
    }
    return s;
  }
  function u(p) {
    var s;
    return (s = a(p)) == null ? void 0 : s.queries;
  }
  function w(p, s) {
    var f;
    return (f = u(p)) == null ? void 0 : f[s];
  }
  function b(p) {
    var s;
    return (s = a(p)) == null ? void 0 : s.mutations;
  }
  function O(p) {
    var s;
    return (s = a(p)) == null ? void 0 : s.config;
  }
  function R(p, s, f) {
    return (P) => {
      if (P === ne)
        return r(n, f);
      const _ = e({
        queryArgs: P,
        endpointDefinition: s,
        endpointName: p
      });
      return r((g) => w(g, _) ?? Xt, f);
    };
  }
  function l(p, s) {
    return R(p, s, o);
  }
  function m(p, s) {
    const {
      infiniteQueryOptions: f
    } = s;
    function P(_) {
      const T = {
        ..._,
        ...Bt(_.status)
      }, {
        isLoading: g,
        isError: d,
        direction: c
      } = T, h = c === "forward", y = c === "backward";
      return {
        ...T,
        hasNextPage: v(f, T.data, T.originalArgs),
        hasPreviousPage: C(f, T.data, T.originalArgs),
        isFetchingNextPage: g && h,
        isFetchingPreviousPage: g && y,
        isFetchNextPageError: d && h,
        isFetchPreviousPageError: d && y
      };
    }
    return R(p, s, P);
  }
  function S() {
    return (p) => {
      let s;
      return typeof p == "object" ? s = $e(p) ?? ne : s = p, r(s === ne ? i : (_) => {
        var T, g;
        return ((g = (T = a(_)) == null ? void 0 : T.mutations) == null ? void 0 : g[s]) ?? er;
      }, o);
    };
  }
  function A(p, s) {
    const f = p[t], P = /* @__PURE__ */ new Set();
    for (const _ of s.filter(Ze).map(_t)) {
      const T = f.provided.tags[_.type];
      if (!T)
        continue;
      let g = (_.id !== void 0 ? (
        // id given: invalidate all queries that provide this type & id
        T[_.id]
      ) : (
        // no id: invalidate all queries that provide this type
        Gt(Object.values(T))
      )) ?? [];
      for (const d of g)
        P.add(d);
    }
    return Gt(Array.from(P.values()).map((_) => {
      const T = f.queries[_];
      return T ? [{
        queryCacheKey: _,
        endpointName: T.endpointName,
        originalArgs: T.originalArgs
      }] : [];
    }));
  }
  function I(p, s) {
    return Object.values(u(p)).filter(
      (f) => (f == null ? void 0 : f.endpointName) === s && f.status !== "uninitialized"
      /* uninitialized */
    ).map((f) => f.originalArgs);
  }
  function v(p, s, f) {
    return s ? At(p, s, f) != null : !1;
  }
  function C(p, s, f) {
    return !s || !p.getPreviousPageParam ? !1 : qr(p, s, f) != null;
  }
}
var Ie = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, et = ({
  endpointName: e,
  queryArgs: t
}) => {
  let r = "";
  const n = Ie == null ? void 0 : Ie.get(t);
  if (typeof n == "string")
    r = n;
  else {
    const i = JSON.stringify(t, (o, a) => (a = typeof a == "bigint" ? {
      $bigint: a.toString()
    } : a, a = De(a) ? Object.keys(a).sort().reduce((u, w) => (u[w] = a[w], u), {}) : a, a));
    De(t) && (Ie == null || Ie.set(t, i)), r = i;
  }
  return `${e}(${r})`;
};
function Nr(...e) {
  return function(r) {
    const n = Ye((b) => {
      var O;
      return (O = r.extractRehydrationInfo) == null ? void 0 : O.call(r, b, {
        reducerPath: r.reducerPath ?? "api"
      });
    }), i = {
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1,
      invalidationBehavior: "delayed",
      ...r,
      extractRehydrationInfo: n,
      serializeQueryArgs(b) {
        let O = et;
        if ("serializeQueryArgs" in b.endpointDefinition) {
          const R = b.endpointDefinition.serializeQueryArgs;
          O = (l) => {
            const m = R(l);
            return typeof m == "string" ? m : et({
              ...l,
              queryArgs: m
            });
          };
        } else r.serializeQueryArgs && (O = r.serializeQueryArgs);
        return O(b);
      },
      tagTypes: [...r.tagTypes || []]
    }, o = {
      endpointDefinitions: {},
      batch(b) {
        b();
      },
      apiUid: hr(),
      extractRehydrationInfo: n,
      hasRehydrationInfo: Ye((b) => n(b) != null)
    }, a = {
      injectEndpoints: w,
      enhanceEndpoints({
        addTagTypes: b,
        endpoints: O
      }) {
        if (b)
          for (const R of b)
            i.tagTypes.includes(R) || i.tagTypes.push(R);
        if (O)
          for (const [R, l] of Object.entries(O))
            typeof l == "function" ? l(o.endpointDefinitions[R]) : Object.assign(o.endpointDefinitions[R] || {}, l);
        return a;
      }
    }, u = e.map((b) => b.init(a, i, o));
    function w(b) {
      const O = b.endpoints({
        query: (R) => ({
          ...R,
          type: "query"
          /* query */
        }),
        mutation: (R) => ({
          ...R,
          type: "mutation"
          /* mutation */
        }),
        infiniteQuery: (R) => ({
          ...R,
          type: "infinitequery"
          /* infinitequery */
        })
      });
      for (const [R, l] of Object.entries(O)) {
        if (b.overrideExisting !== !0 && R in o.endpointDefinitions) {
          if (b.overrideExisting === "throw")
            throw new Error(process.env.NODE_ENV === "production" ? he(39) : `called \`injectEndpoints\` to override already-existing endpointName ${R} without specifying \`overrideExisting: true\``);
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error(`called \`injectEndpoints\` to override already-existing endpointName ${R} without specifying \`overrideExisting: true\``);
          continue;
        }
        if (typeof process < "u" && process.env.NODE_ENV === "development" && ze(l)) {
          const {
            infiniteQueryOptions: m
          } = l, {
            maxPages: S,
            getPreviousPageParam: A
          } = m;
          if (typeof S == "number") {
            if (S < 1)
              throw new Error(process.env.NODE_ENV === "production" ? he(40) : `maxPages for endpoint '${R}' must be a number greater than 0`);
            if (typeof A != "function")
              throw new Error(process.env.NODE_ENV === "production" ? he(41) : `getPreviousPageParam for endpoint '${R}' must be a function if maxPages is used`);
          }
        }
        o.endpointDefinitions[R] = l;
        for (const m of u)
          m.injectEndpoint(R, l);
      }
      return a;
    }
    return a.injectEndpoints({
      endpoints: r.endpoints
    });
  };
}
function oe(e, ...t) {
  return Object.assign(e, ...t);
}
var xn = ({
  api: e,
  queryThunk: t,
  internalState: r
}) => {
  const n = `${e.reducerPath}/subscriptions`;
  let i = null, o = null;
  const {
    updateSubscriptionOptions: a,
    unsubscribeQueryResult: u
  } = e.internalActions, w = (m, S) => {
    var I, v, C;
    if (a.match(S)) {
      const {
        queryCacheKey: p,
        requestId: s,
        options: f
      } = S.payload;
      return (I = m == null ? void 0 : m[p]) != null && I[s] && (m[p][s] = f), !0;
    }
    if (u.match(S)) {
      const {
        queryCacheKey: p,
        requestId: s
      } = S.payload;
      return m[p] && delete m[p][s], !0;
    }
    if (e.internalActions.removeQueryResult.match(S))
      return delete m[S.payload.queryCacheKey], !0;
    if (t.pending.match(S)) {
      const {
        meta: {
          arg: p,
          requestId: s
        }
      } = S, f = m[v = p.queryCacheKey] ?? (m[v] = {});
      return f[`${s}_running`] = {}, p.subscribe && (f[s] = p.subscriptionOptions ?? f[s] ?? {}), !0;
    }
    let A = !1;
    if (t.fulfilled.match(S) || t.rejected.match(S)) {
      const p = m[S.meta.arg.queryCacheKey] || {}, s = `${S.meta.requestId}_running`;
      A || (A = !!p[s]), delete p[s];
    }
    if (t.rejected.match(S)) {
      const {
        meta: {
          condition: p,
          arg: s,
          requestId: f
        }
      } = S;
      if (p && s.subscribe) {
        const P = m[C = s.queryCacheKey] ?? (m[C] = {});
        P[f] = s.subscriptionOptions ?? P[f] ?? {}, A = !0;
      }
    }
    return A;
  }, b = () => r.currentSubscriptions, l = {
    getSubscriptions: b,
    getSubscriptionCount: (m) => {
      const A = b()[m] ?? {};
      return Te(A);
    },
    isRequestSubscribed: (m, S) => {
      var I;
      const A = b();
      return !!((I = A == null ? void 0 : A[m]) != null && I[S]);
    }
  };
  return (m, S) => {
    if (i || (i = JSON.parse(JSON.stringify(r.currentSubscriptions))), e.util.resetApiState.match(m))
      return i = r.currentSubscriptions = {}, o = null, [!0, !1];
    if (e.internalActions.internal_getRTKQSubscriptions.match(m))
      return [!1, l];
    const A = w(r.currentSubscriptions, m);
    let I = !0;
    if (A) {
      o || (o = setTimeout(() => {
        const p = JSON.parse(JSON.stringify(r.currentSubscriptions)), [, s] = Ir(i, () => p);
        S.next(e.internalActions.subscriptionsUpdated(s)), i = p, o = null;
      }, 500));
      const v = typeof m.type == "string" && !!m.type.startsWith(n), C = t.rejected.match(m) && m.meta.condition && !!m.meta.arg.subscribe;
      I = !v && !C;
    }
    return [I, !1];
  };
};
function Fn(e) {
  for (const t in e)
    return !1;
  return !0;
}
var zn = 2147483647 / 1e3 - 1, jn = ({
  reducerPath: e,
  api: t,
  queryThunk: r,
  context: n,
  internalState: i,
  selectors: {
    selectQueryEntry: o,
    selectConfig: a
  }
}) => {
  const {
    removeQueryResult: u,
    unsubscribeQueryResult: w,
    cacheEntriesUpserted: b
  } = t.internalActions, O = Be(w.match, r.fulfilled, r.rejected, b.match);
  function R(I) {
    const v = i.currentSubscriptions[I];
    return !!v && !Fn(v);
  }
  const l = {}, m = (I, v, C) => {
    const p = v.getState(), s = a(p);
    if (O(I)) {
      let f;
      if (b.match(I))
        f = I.payload.map((P) => P.queryDescription.queryCacheKey);
      else {
        const {
          queryCacheKey: P
        } = w.match(I) ? I.payload : I.meta.arg;
        f = [P];
      }
      S(f, v, s);
    }
    if (t.util.resetApiState.match(I))
      for (const [f, P] of Object.entries(l))
        P && clearTimeout(P), delete l[f];
    if (n.hasRehydrationInfo(I)) {
      const {
        queries: f
      } = n.extractRehydrationInfo(I);
      S(Object.keys(f), v, s);
    }
  };
  function S(I, v, C) {
    const p = v.getState();
    for (const s of I) {
      const f = o(p, s);
      A(s, f == null ? void 0 : f.endpointName, v, C);
    }
  }
  function A(I, v, C, p) {
    const s = n.endpointDefinitions[v], f = (s == null ? void 0 : s.keepUnusedDataFor) ?? p.keepUnusedDataFor;
    if (f === 1 / 0)
      return;
    const P = Math.max(0, Math.min(f, zn));
    if (!R(I)) {
      const _ = l[I];
      _ && clearTimeout(_), l[I] = setTimeout(() => {
        R(I) || C.dispatch(u({
          queryCacheKey: I
        })), delete l[I];
      }, P * 1e3);
    }
  }
  return m;
}, tr = new Error("Promise never resolved before cacheEntryRemoved."), Un = ({
  api: e,
  reducerPath: t,
  context: r,
  queryThunk: n,
  mutationThunk: i,
  internalState: o,
  selectors: {
    selectQueryEntry: a,
    selectApiState: u
  }
}) => {
  const w = $t(n), b = $t(i), O = me(n, i), R = {};
  function l(v, C, p) {
    const s = R[v];
    s != null && s.valueResolved && (s.valueResolved({
      data: C,
      meta: p
    }), delete s.valueResolved);
  }
  function m(v) {
    const C = R[v];
    C && (delete R[v], C.cacheEntryRemoved());
  }
  const S = (v, C, p) => {
    const s = A(v);
    function f(P, _, T, g) {
      const d = a(p, _), c = a(C.getState(), _);
      !d && c && I(P, g, _, C, T);
    }
    if (n.pending.match(v))
      f(v.meta.arg.endpointName, s, v.meta.requestId, v.meta.arg.originalArgs);
    else if (e.internalActions.cacheEntriesUpserted.match(v))
      for (const {
        queryDescription: P,
        value: _
      } of v.payload) {
        const {
          endpointName: T,
          originalArgs: g,
          queryCacheKey: d
        } = P;
        f(T, d, v.meta.requestId, g), l(d, _, {});
      }
    else if (i.pending.match(v))
      C.getState()[t].mutations[s] && I(v.meta.arg.endpointName, v.meta.arg.originalArgs, s, C, v.meta.requestId);
    else if (O(v))
      l(s, v.payload, v.meta.baseQueryMeta);
    else if (e.internalActions.removeQueryResult.match(v) || e.internalActions.removeMutationResult.match(v))
      m(s);
    else if (e.util.resetApiState.match(v))
      for (const P of Object.keys(R))
        m(P);
  };
  function A(v) {
    return w(v) ? v.meta.arg.queryCacheKey : b(v) ? v.meta.arg.fixedCacheKey ?? v.meta.requestId : e.internalActions.removeQueryResult.match(v) ? v.payload.queryCacheKey : e.internalActions.removeMutationResult.match(v) ? $e(v.payload) : "";
  }
  function I(v, C, p, s, f) {
    const P = r.endpointDefinitions[v], _ = P == null ? void 0 : P.onCacheEntryAdded;
    if (!_) return;
    const T = {}, g = new Promise((q) => {
      T.cacheEntryRemoved = q;
    }), d = Promise.race([new Promise((q) => {
      T.valueResolved = q;
    }), g.then(() => {
      throw tr;
    })]);
    d.catch(() => {
    }), R[p] = T;
    const c = e.endpoints[v].select(Xe(P) ? C : p), h = s.dispatch((q, N, L) => L), y = {
      ...s,
      getCacheEntry: () => c(s.getState()),
      requestId: f,
      extra: h,
      updateCachedData: Xe(P) ? (q) => s.dispatch(e.util.updateQueryData(v, C, q)) : void 0,
      cacheDataLoaded: d,
      cacheEntryRemoved: g
    }, E = _(C, y);
    Promise.resolve(E).catch((q) => {
      if (q !== tr)
        throw q;
    });
  }
  return S;
}, Vn = ({
  api: e,
  context: {
    apiUid: t
  },
  reducerPath: r
}) => (n, i) => {
  var o, a;
  e.util.resetApiState.match(n) && i.dispatch(e.internalActions.middlewareRegistered(t)), typeof process < "u" && process.env.NODE_ENV === "development" && e.internalActions.middlewareRegistered.match(n) && n.payload === t && ((a = (o = i.getState()[r]) == null ? void 0 : o.config) == null ? void 0 : a.middlewareRegistered) === "conflict" && console.warn(`There is a mismatch between slice and middleware for the reducerPath "${r}".
You can only have one api per reducer path, this will lead to crashes in various situations!${r === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""}`);
}, Kn = ({
  reducerPath: e,
  context: t,
  context: {
    endpointDefinitions: r
  },
  mutationThunk: n,
  queryThunk: i,
  api: o,
  assertTagType: a,
  refetchQuery: u,
  internalState: w
}) => {
  const {
    removeQueryResult: b
  } = o.internalActions, O = Be(me(n), Rt(n)), R = Be(me(n, i), Pt(n, i));
  let l = [];
  const m = (I, v) => {
    O(I) ? A(Dr(I, "invalidatesTags", r, a), v) : R(I) ? A([], v) : o.util.invalidateTags.match(I) && A(Lt(I.payload, void 0, void 0, void 0, void 0, a), v);
  };
  function S(I) {
    var p;
    const {
      queries: v,
      mutations: C
    } = I;
    for (const s of [v, C])
      for (const f in s)
        if (((p = s[f]) == null ? void 0 : p.status) === "pending") return !0;
    return !1;
  }
  function A(I, v) {
    const C = v.getState(), p = C[e];
    if (l.push(...I), p.config.invalidationBehavior === "delayed" && S(p))
      return;
    const s = l;
    if (l = [], s.length === 0) return;
    const f = o.util.selectInvalidatedBy(C, s);
    t.batch(() => {
      const P = Array.from(f.values());
      for (const {
        queryCacheKey: _
      } of P) {
        const T = p.queries[_], g = w.currentSubscriptions[_] ?? {};
        T && (Te(g) === 0 ? v.dispatch(b({
          queryCacheKey: _
        })) : T.status !== "uninitialized" && v.dispatch(u(T)));
      }
    });
  }
  return m;
}, Hn = ({
  reducerPath: e,
  queryThunk: t,
  api: r,
  refetchQuery: n,
  internalState: i
}) => {
  const o = {}, a = (l, m) => {
    (r.internalActions.updateSubscriptionOptions.match(l) || r.internalActions.unsubscribeQueryResult.match(l)) && w(l.payload, m), (t.pending.match(l) || t.rejected.match(l) && l.meta.condition) && w(l.meta.arg, m), (t.fulfilled.match(l) || t.rejected.match(l) && !l.meta.condition) && u(l.meta.arg, m), r.util.resetApiState.match(l) && O();
  };
  function u({
    queryCacheKey: l
  }, m) {
    const S = m.getState()[e], A = S.queries[l], I = i.currentSubscriptions[l];
    if (!A || A.status === "uninitialized") return;
    const {
      lowestPollingInterval: v,
      skipPollingIfUnfocused: C
    } = R(I);
    if (!Number.isFinite(v)) return;
    const p = o[l];
    p != null && p.timeout && (clearTimeout(p.timeout), p.timeout = void 0);
    const s = Date.now() + v;
    o[l] = {
      nextPollTimestamp: s,
      pollingInterval: v,
      timeout: setTimeout(() => {
        (S.config.focused || !C) && m.dispatch(n(A)), u({
          queryCacheKey: l
        }, m);
      }, v)
    };
  }
  function w({
    queryCacheKey: l
  }, m) {
    const A = m.getState()[e].queries[l], I = i.currentSubscriptions[l];
    if (!A || A.status === "uninitialized")
      return;
    const {
      lowestPollingInterval: v
    } = R(I);
    if (!Number.isFinite(v)) {
      b(l);
      return;
    }
    const C = o[l], p = Date.now() + v;
    (!C || p < C.nextPollTimestamp) && u({
      queryCacheKey: l
    }, m);
  }
  function b(l) {
    const m = o[l];
    m != null && m.timeout && clearTimeout(m.timeout), delete o[l];
  }
  function O() {
    for (const l of Object.keys(o))
      b(l);
  }
  function R(l = {}) {
    let m = !1, S = Number.POSITIVE_INFINITY;
    for (let A in l)
      l[A].pollingInterval && (S = Math.min(l[A].pollingInterval, S), m = l[A].skipPollingIfUnfocused || m);
    return {
      lowestPollingInterval: S,
      skipPollingIfUnfocused: m
    };
  }
  return a;
}, Wn = ({
  api: e,
  context: t,
  queryThunk: r,
  mutationThunk: n
}) => {
  const i = gr(r, n), o = Pt(r, n), a = me(r, n), u = {};
  return (b, O) => {
    var R, l;
    if (i(b)) {
      const {
        requestId: m,
        arg: {
          endpointName: S,
          originalArgs: A
        }
      } = b.meta, I = t.endpointDefinitions[S], v = I == null ? void 0 : I.onQueryStarted;
      if (v) {
        const C = {}, p = new Promise((_, T) => {
          C.resolve = _, C.reject = T;
        });
        p.catch(() => {
        }), u[m] = C;
        const s = e.endpoints[S].select(Xe(I) ? A : m), f = O.dispatch((_, T, g) => g), P = {
          ...O,
          getCacheEntry: () => s(O.getState()),
          requestId: m,
          extra: f,
          updateCachedData: Xe(I) ? (_) => O.dispatch(e.util.updateQueryData(S, A, _)) : void 0,
          queryFulfilled: p
        };
        v(A, P);
      }
    } else if (a(b)) {
      const {
        requestId: m,
        baseQueryMeta: S
      } = b.meta;
      (R = u[m]) == null || R.resolve({
        data: b.payload,
        meta: S
      }), delete u[m];
    } else if (o(b)) {
      const {
        requestId: m,
        rejectedWithValue: S,
        baseQueryMeta: A
      } = b.meta;
      (l = u[m]) == null || l.reject({
        error: b.payload ?? b.error,
        isUnhandledError: !S,
        meta: A
      }), delete u[m];
    }
  };
}, Bn = ({
  reducerPath: e,
  context: t,
  api: r,
  refetchQuery: n,
  internalState: i
}) => {
  const {
    removeQueryResult: o
  } = r.internalActions, a = (w, b) => {
    qt.match(w) && u(b, "refetchOnFocus"), Dt.match(w) && u(b, "refetchOnReconnect");
  };
  function u(w, b) {
    const O = w.getState()[e], R = O.queries, l = i.currentSubscriptions;
    t.batch(() => {
      for (const m of Object.keys(l)) {
        const S = R[m], A = l[m];
        if (!A || !S) continue;
        (Object.values(A).some((v) => v[b] === !0) || Object.values(A).every((v) => v[b] === void 0) && O.config[b]) && (Te(A) === 0 ? w.dispatch(o({
          queryCacheKey: m
        })) : S.status !== "uninitialized" && w.dispatch(n(S)));
      }
    });
  }
  return a;
};
function Jn(e) {
  const {
    reducerPath: t,
    queryThunk: r,
    api: n,
    context: i
  } = e, {
    apiUid: o
  } = i, a = {
    invalidateTags: Re(`${t}/invalidateTags`)
  }, u = (R) => R.type.startsWith(`${t}/`), w = [Vn, jn, Kn, Hn, Un, Wn];
  return {
    middleware: (R) => {
      let l = !1;
      const S = {
        ...e,
        internalState: {
          currentSubscriptions: {}
        },
        refetchQuery: O,
        isThisApiSliceAction: u
      }, A = w.map((C) => C(S)), I = xn(S), v = Bn(S);
      return (C) => (p) => {
        if (!Jr(p))
          return C(p);
        l || (l = !0, R.dispatch(n.internalActions.middlewareRegistered(o)));
        const s = {
          ...R,
          next: C
        }, f = R.getState(), [P, _] = I(p, s, f);
        let T;
        if (P ? T = C(p) : T = _, R.getState()[t] && (v(p, s, f), u(p) || i.hasRehydrationInfo(p)))
          for (const g of A)
            g(p, s, f);
        return T;
      };
    },
    actions: a
  };
  function O(R) {
    return e.api.endpoints[R.endpointName].initiate(R.originalArgs, {
      subscribe: !1,
      forceRefetch: !0
    });
  }
}
var rr = /* @__PURE__ */ Symbol(), Qr = ({
  createSelector: e = Wr
} = {}) => ({
  name: rr,
  init(t, {
    baseQuery: r,
    tagTypes: n,
    reducerPath: i,
    serializeQueryArgs: o,
    keepUnusedDataFor: a,
    refetchOnMountOrArgChange: u,
    refetchOnFocus: w,
    refetchOnReconnect: b,
    invalidationBehavior: O,
    onSchemaFailure: R,
    catchSchemaFailure: l,
    skipSchemaValidation: m
  }, S) {
    pn();
    const A = (k) => (typeof process < "u" && process.env.NODE_ENV === "development" && (n.includes(k.type) || console.error(`Tag type '${k.type}' was used, but not specified in \`tagTypes\`!`)), k);
    Object.assign(t, {
      reducerPath: i,
      endpoints: {},
      internalActions: {
        onOnline: Dt,
        onOffline: Or,
        onFocus: qt,
        onFocusLost: wr
      },
      util: {}
    });
    const I = $n({
      serializeQueryArgs: o,
      reducerPath: i,
      createSelector: e
    }), {
      selectInvalidatedBy: v,
      selectCachedArgsForQuery: C,
      buildQuerySelector: p,
      buildInfiniteQuerySelector: s,
      buildMutationSelector: f
    } = I;
    oe(t.util, {
      selectInvalidatedBy: v,
      selectCachedArgsForQuery: C
    });
    const {
      queryThunk: P,
      infiniteQueryThunk: _,
      mutationThunk: T,
      patchQueryData: g,
      updateQueryData: d,
      upsertQueryData: c,
      prefetch: h,
      buildMatchThunkActions: y
    } = Mn({
      baseQuery: r,
      reducerPath: i,
      context: S,
      api: t,
      serializeQueryArgs: o,
      assertTagType: A,
      selectors: I,
      onSchemaFailure: R,
      catchSchemaFailure: l,
      skipSchemaValidation: m
    }), {
      reducer: E,
      actions: q
    } = kn({
      context: S,
      queryThunk: P,
      mutationThunk: T,
      serializeQueryArgs: o,
      reducerPath: i,
      assertTagType: A,
      config: {
        refetchOnFocus: w,
        refetchOnReconnect: b,
        refetchOnMountOrArgChange: u,
        keepUnusedDataFor: a,
        reducerPath: i,
        invalidationBehavior: O
      }
    });
    oe(t.util, {
      patchQueryData: g,
      updateQueryData: d,
      upsertQueryData: c,
      prefetch: h,
      resetApiState: q.resetApiState,
      upsertQueryEntries: q.cacheEntriesUpserted
    }), oe(t.internalActions, q);
    const {
      middleware: N,
      actions: L
    } = Jn({
      reducerPath: i,
      context: S,
      queryThunk: P,
      mutationThunk: T,
      infiniteQueryThunk: _,
      api: t,
      assertTagType: A,
      selectors: I
    });
    oe(t.util, L), oe(t, {
      reducer: E,
      middleware: N
    });
    const {
      buildInitiateQuery: M,
      buildInitiateInfiniteQuery: Q,
      buildInitiateMutation: $,
      getRunningMutationThunk: x,
      getRunningMutationsThunk: U,
      getRunningQueriesThunk: W,
      getRunningQueryThunk: B
    } = Nn({
      queryThunk: P,
      mutationThunk: T,
      infiniteQueryThunk: _,
      api: t,
      serializeQueryArgs: o,
      context: S
    });
    return oe(t.util, {
      getRunningMutationThunk: x,
      getRunningMutationsThunk: U,
      getRunningQueryThunk: B,
      getRunningQueriesThunk: W
    }), {
      name: rr,
      injectEndpoint(k, z) {
        var ee;
        const j = (ee = t.endpoints)[k] ?? (ee[k] = {});
        nt(z) && oe(j, {
          name: k,
          select: p(k, z),
          initiate: M(k, z)
        }, y(P, k)), qn(z) && oe(j, {
          name: k,
          select: f(),
          initiate: $(k)
        }, y(T, k)), ze(z) && oe(j, {
          name: k,
          select: s(k, z),
          initiate: Q(k, z)
        }, y(P, k));
      }
    };
  }
}), Gn = /* @__PURE__ */ Nr(Qr());
function Ke(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
function Yn(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
function Zn(e) {
  return e.type === "query";
}
function Xn(e) {
  return e.type === "mutation";
}
function Mr(e) {
  return e.type === "infinitequery";
}
function Oe(e, ...t) {
  return Object.assign(e, ...t);
}
var ut = Symbol();
function lt(e, t, r, n) {
  const i = Y(() => ({
    queryArgs: e,
    serialized: typeof e == "object" ? t({
      queryArgs: e,
      endpointDefinition: r,
      endpointName: n
    }) : e
  }), [e, t, r, n]), o = le(i);
  return de(() => {
    o.current.serialized !== i.serialized && (o.current = i);
  }, [i]), o.current.serialized === i.serialized ? o.current.queryArgs : e;
}
function He(e) {
  const t = le(e);
  return de(() => {
    Ce(t.current, e) || (t.current = e);
  }, [e]), Ce(t.current, e) ? t.current : e;
}
var ei = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ti = /* @__PURE__ */ ei(), ri = () => typeof navigator < "u" && navigator.product === "ReactNative", ni = /* @__PURE__ */ ri(), ii = () => ti || ni ? en : de, si = /* @__PURE__ */ ii(), nr = (e) => e.isUninitialized ? {
  ...e,
  isUninitialized: !1,
  isFetching: !0,
  isLoading: e.data === void 0,
  status: Rr.pending
} : e;
function dt(e, ...t) {
  const r = {};
  return t.forEach((n) => {
    r[n] = e[n];
  }), r;
}
var ft = ["data", "status", "isLoading", "isSuccess", "isError", "error"];
function oi({
  api: e,
  moduleOptions: {
    batch: t,
    hooks: {
      useDispatch: r,
      useSelector: n,
      useStore: i
    },
    unstable__sideEffectsInRender: o,
    createSelector: a
  },
  serializeQueryArgs: u,
  context: w
}) {
  const b = o ? (s) => s() : de;
  return {
    buildQueryHooks: v,
    buildInfiniteQueryHooks: C,
    buildMutationHook: p,
    usePrefetch: l
  };
  function O(s, f, P) {
    if (f != null && f.endpointName && s.isUninitialized) {
      const {
        endpointName: h
      } = f, y = w.endpointDefinitions[h];
      P !== ne && u({
        queryArgs: f.originalArgs,
        endpointDefinition: y,
        endpointName: h
      }) === u({
        queryArgs: P,
        endpointDefinition: y,
        endpointName: h
      }) && (f = void 0);
    }
    let _ = s.isSuccess ? s.data : f == null ? void 0 : f.data;
    _ === void 0 && (_ = s.data);
    const T = _ !== void 0, g = s.isLoading, d = (!f || f.isLoading || f.isUninitialized) && !T && g, c = s.isSuccess || T && (g && !(f != null && f.isError) || s.isUninitialized);
    return {
      ...s,
      data: _,
      currentData: s.data,
      isFetching: g,
      isLoading: d,
      isSuccess: c
    };
  }
  function R(s, f, P) {
    if (f != null && f.endpointName && s.isUninitialized) {
      const {
        endpointName: h
      } = f, y = w.endpointDefinitions[h];
      P !== ne && u({
        queryArgs: f.originalArgs,
        endpointDefinition: y,
        endpointName: h
      }) === u({
        queryArgs: P,
        endpointDefinition: y,
        endpointName: h
      }) && (f = void 0);
    }
    let _ = s.isSuccess ? s.data : f == null ? void 0 : f.data;
    _ === void 0 && (_ = s.data);
    const T = _ !== void 0, g = s.isLoading, d = (!f || f.isLoading || f.isUninitialized) && !T && g, c = s.isSuccess || g && T;
    return {
      ...s,
      data: _,
      currentData: s.data,
      isFetching: g,
      isLoading: d,
      isSuccess: c
    };
  }
  function l(s, f) {
    const P = r(), _ = He(f);
    return fe((T, g) => P(e.util.prefetch(s, T, {
      ..._,
      ...g
    })), [s, P, _]);
  }
  function m(s, f, {
    refetchOnReconnect: P,
    refetchOnFocus: _,
    refetchOnMountOrArgChange: T,
    skip: g = !1,
    pollingInterval: d = 0,
    skipPollingIfUnfocused: c = !1,
    ...h
  } = {}) {
    const {
      initiate: y
    } = e.endpoints[s], E = r(), q = le(void 0);
    if (!q.current) {
      const k = E(e.internalActions.internal_getRTKQSubscriptions());
      if (process.env.NODE_ENV !== "production" && (typeof k != "object" || typeof (k == null ? void 0 : k.type) == "string"))
        throw new Error(process.env.NODE_ENV === "production" ? he(37) : `Warning: Middleware for RTK-Query API at reducerPath "${e.reducerPath}" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
      q.current = k;
    }
    const N = lt(
      g ? ne : f,
      // Even if the user provided a per-endpoint `serializeQueryArgs` with
      // a consistent return value, _here_ we want to use the default behavior
      // so we can tell if _anything_ actually changed. Otherwise, we can end up
      // with a case where the query args did change but the serialization doesn't,
      // and then we never try to initiate a refetch.
      et,
      w.endpointDefinitions[s],
      s
    ), L = He({
      refetchOnReconnect: P,
      refetchOnFocus: _,
      pollingInterval: d,
      skipPollingIfUnfocused: c
    }), M = h.initialPageParam, Q = He(M), $ = le(void 0);
    let {
      queryCacheKey: x,
      requestId: U
    } = $.current || {}, W = !1;
    x && U && (W = q.current.isRequestSubscribed(x, U));
    const B = !W && $.current !== void 0;
    return b(() => {
      B && ($.current = void 0);
    }, [B]), b(() => {
      var K;
      const k = $.current;
      if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(B), N === ne) {
        k == null || k.unsubscribe(), $.current = void 0;
        return;
      }
      const z = (K = $.current) == null ? void 0 : K.subscriptionOptions;
      if (!k || k.arg !== N) {
        k == null || k.unsubscribe();
        const j = E(y(N, {
          subscriptionOptions: L,
          forceRefetch: T,
          ...Mr(w.endpointDefinitions[s]) ? {
            initialPageParam: Q
          } : {}
        }));
        $.current = j;
      } else L !== z && k.updateSubscriptionOptions(L);
    }, [E, y, T, N, L, B, Q, s]), [$, E, y, L];
  }
  function S(s, f) {
    return (_, {
      skip: T = !1,
      selectFromResult: g
    } = {}) => {
      const {
        select: d
      } = e.endpoints[s], c = lt(T ? ne : _, u, w.endpointDefinitions[s], s), h = le(void 0), y = Y(() => (
        // Normally ts-ignores are bad and should be avoided, but we're
        // already casting this selector to be `Selector<any>` anyway,
        // so the inconsistencies don't matter here
        // @ts-ignore
        a([
          // @ts-ignore
          d(c),
          (M, Q) => Q,
          (M) => c
        ], f, {
          memoizeOptions: {
            resultEqualityCheck: Ce
          }
        })
      ), [d, c]), E = Y(() => g ? a([y], g, {
        devModeChecks: {
          identityFunctionCheck: "never"
        }
      }) : y, [y, g]), q = n((M) => E(M, h.current), Ce), N = i(), L = y(N.getState(), h.current);
      return si(() => {
        h.current = L;
      }, [L]), q;
    };
  }
  function A(s) {
    de(() => () => {
      var f, P;
      (P = (f = s.current) == null ? void 0 : f.unsubscribe) == null || P.call(f), s.current = void 0;
    }, [s]);
  }
  function I(s) {
    if (!s.current) throw new Error(process.env.NODE_ENV === "production" ? he(38) : "Cannot refetch a query that has not been started yet.");
    return s.current.refetch();
  }
  function v(s) {
    const f = (T, g = {}) => {
      const [d] = m(s, T, g);
      return A(d), Y(() => ({
        /**
         * A method to manually refetch data for the query
         */
        refetch: () => I(d)
      }), [d]);
    }, P = ({
      refetchOnReconnect: T,
      refetchOnFocus: g,
      pollingInterval: d = 0,
      skipPollingIfUnfocused: c = !1
    } = {}) => {
      const {
        initiate: h
      } = e.endpoints[s], y = r(), [E, q] = xt(ut), N = le(void 0), L = He({
        refetchOnReconnect: T,
        refetchOnFocus: g,
        pollingInterval: d,
        skipPollingIfUnfocused: c
      });
      b(() => {
        var U, W;
        const x = (U = N.current) == null ? void 0 : U.subscriptionOptions;
        L !== x && ((W = N.current) == null || W.updateSubscriptionOptions(L));
      }, [L]);
      const M = le(L);
      b(() => {
        M.current = L;
      }, [L]);
      const Q = fe(function(x, U = !1) {
        let W;
        return t(() => {
          var B;
          (B = N.current) == null || B.unsubscribe(), N.current = W = y(h(x, {
            subscriptionOptions: M.current,
            forceRefetch: !U
          })), q(x);
        }), W;
      }, [y, h]), $ = fe(() => {
        var x, U;
        (x = N.current) != null && x.queryCacheKey && y(e.internalActions.removeQueryResult({
          queryCacheKey: (U = N.current) == null ? void 0 : U.queryCacheKey
        }));
      }, [y]);
      return de(() => () => {
        var x;
        (x = N == null ? void 0 : N.current) == null || x.unsubscribe();
      }, []), de(() => {
        E !== ut && !N.current && Q(E, !0);
      }, [E, Q]), Y(() => [Q, E, {
        reset: $
      }], [Q, E, $]);
    }, _ = S(s, O);
    return {
      useQueryState: _,
      useQuerySubscription: f,
      useLazyQuerySubscription: P,
      useLazyQuery(T) {
        const [g, d, {
          reset: c
        }] = P(T), h = _(d, {
          ...T,
          skip: d === ut
        }), y = Y(() => ({
          lastArg: d
        }), [d]);
        return Y(() => [g, {
          ...h,
          reset: c
        }, y], [g, h, c, y]);
      },
      useQuery(T, g) {
        const d = f(T, g), c = _(T, {
          selectFromResult: T === ne || g != null && g.skip ? void 0 : nr,
          ...g
        }), h = dt(c, ...ft);
        return st(h), Y(() => ({
          ...c,
          ...d
        }), [c, d]);
      }
    };
  }
  function C(s) {
    const f = (_, T = {}) => {
      const [g, d, c, h] = m(s, _, T), y = le(h);
      b(() => {
        y.current = h;
      }, [h]);
      const E = fe(function(L, M) {
        let Q;
        return t(() => {
          var $;
          ($ = g.current) == null || $.unsubscribe(), g.current = Q = d(c(L, {
            subscriptionOptions: y.current,
            direction: M
          }));
        }), Q;
      }, [g, d, c]);
      A(g);
      const q = lt(
        T.skip ? ne : _,
        // Even if the user provided a per-endpoint `serializeQueryArgs` with
        // a consistent return value, _here_ we want to use the default behavior
        // so we can tell if _anything_ actually changed. Otherwise, we can end up
        // with a case where the query args did change but the serialization doesn't,
        // and then we never try to initiate a refetch.
        et,
        w.endpointDefinitions[s],
        s
      ), N = fe(() => I(g), [g]);
      return Y(() => ({
        trigger: E,
        /**
         * A method to manually refetch data for the query
         */
        refetch: N,
        fetchNextPage: () => E(q, "forward"),
        fetchPreviousPage: () => E(q, "backward")
      }), [N, E, q]);
    }, P = S(s, R);
    return {
      useInfiniteQueryState: P,
      useInfiniteQuerySubscription: f,
      useInfiniteQuery(_, T) {
        const {
          refetch: g,
          fetchNextPage: d,
          fetchPreviousPage: c
        } = f(_, T), h = P(_, {
          selectFromResult: _ === ne || T != null && T.skip ? void 0 : nr,
          ...T
        }), y = dt(h, ...ft, "hasNextPage", "hasPreviousPage");
        return st(y), Y(() => ({
          ...h,
          fetchNextPage: d,
          fetchPreviousPage: c,
          refetch: g
        }), [h, d, c, g]);
      }
    };
  }
  function p(s) {
    return ({
      selectFromResult: f,
      fixedCacheKey: P
    } = {}) => {
      const {
        select: _,
        initiate: T
      } = e.endpoints[s], g = r(), [d, c] = xt();
      de(() => () => {
        d != null && d.arg.fixedCacheKey || d == null || d.reset();
      }, [d]);
      const h = fe(function(x) {
        const U = g(T(x, {
          fixedCacheKey: P
        }));
        return c(U), U;
      }, [g, T, P]), {
        requestId: y
      } = d || {}, E = Y(() => _({
        fixedCacheKey: P,
        requestId: d == null ? void 0 : d.requestId
      }), [P, d, _]), q = Y(() => f ? a([E], f) : E, [f, E]), N = n(q, Ce), L = P == null ? d == null ? void 0 : d.arg.originalArgs : void 0, M = fe(() => {
        t(() => {
          d && c(void 0), P && g(e.internalActions.removeMutationResult({
            requestId: y,
            fixedCacheKey: P
          }));
        });
      }, [g, P, d, y]), Q = dt(N, ...ft, "endpointName");
      st(Q);
      const $ = Y(() => ({
        ...N,
        originalArgs: L,
        reset: M
      }), [N, L, M]);
      return Y(() => [h, $], [h, $]);
    };
  }
}
var ai = /* @__PURE__ */ Symbol(), ci = ({
  batch: e = Xr,
  hooks: t = {
    useDispatch: Zr,
    useSelector: Yr,
    useStore: Gr
  },
  createSelector: r = Tr,
  unstable__sideEffectsInRender: n = !1,
  ...i
} = {}) => {
  if (process.env.NODE_ENV !== "production") {
    const o = ["useDispatch", "useSelector", "useStore"];
    let a = !1;
    for (const u of o)
      if (Yn(i) > 0 && (i[u] && (a || (console.warn("As of RTK 2.0, the hooks now need to be specified as one object, provided under a `hooks` key:\n`reactHooksModule({ hooks: { useDispatch, useSelector, useStore } })`"), a = !0)), t[u] = i[u]), typeof t[u] != "function")
        throw new Error(process.env.NODE_ENV === "production" ? he(36) : `When using custom hooks for context, all ${o.length} hooks need to be provided: ${o.join(", ")}.
Hook ${u} was either not provided or not a function.`);
  }
  return {
    name: ai,
    init(o, {
      serializeQueryArgs: a
    }, u) {
      const w = o, {
        buildQueryHooks: b,
        buildInfiniteQueryHooks: O,
        buildMutationHook: R,
        usePrefetch: l
      } = oi({
        api: o,
        moduleOptions: {
          batch: e,
          hooks: t,
          unstable__sideEffectsInRender: n,
          createSelector: r
        },
        serializeQueryArgs: a,
        context: u
      });
      return Oe(w, {
        usePrefetch: l
      }), Oe(u, {
        batch: e
      }), {
        injectEndpoint(m, S) {
          if (Zn(S)) {
            const {
              useQuery: A,
              useLazyQuery: I,
              useLazyQuerySubscription: v,
              useQueryState: C,
              useQuerySubscription: p
            } = b(m);
            Oe(w.endpoints[m], {
              useQuery: A,
              useLazyQuery: I,
              useLazyQuerySubscription: v,
              useQueryState: C,
              useQuerySubscription: p
            }), o[`use${Ke(m)}Query`] = A, o[`useLazy${Ke(m)}Query`] = I;
          }
          if (Xn(S)) {
            const A = R(m);
            Oe(w.endpoints[m], {
              useMutation: A
            }), o[`use${Ke(m)}Mutation`] = A;
          } else if (Mr(S)) {
            const {
              useInfiniteQuery: A,
              useInfiniteQuerySubscription: I,
              useInfiniteQueryState: v
            } = O(m);
            Oe(w.endpoints[m], {
              useInfiniteQuery: A,
              useInfiniteQuerySubscription: I,
              useInfiniteQueryState: v
            }), o[`use${Ke(m)}InfiniteQuery`] = A;
          }
        }
      };
    }
  };
}, ui = /* @__PURE__ */ Nr(Qr(), ci()), D = /* @__PURE__ */ ((e) => (e.Room = "Room", e.Tariff = "Tariff", e.RoomInvite = "RoomInvite", e.User = "User", e.FindUser = "FindUser", e.Event = "Event", e.EventInstance = "EventInstance", e.EventInvite = "EventInvite", e.Asset = "Asset", e.StreamingTargets = "StreamingTargets", e))(D || {});
const kr = Object.entries(D).map(([, e]) => e);
var li = /* @__PURE__ */ ((e) => (e.Accepted = "accepted", e.Tentative = "tentative", e.Pending = "pending", e.Declined = "declined", e.Added = "added", e))(li || {});
function di(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function fi(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var We = { exports: {} }, ir;
function pi() {
  if (ir) return We.exports;
  ir = 1;
  const e = (i) => typeof i == "object" && i !== null, t = Symbol("skip"), r = (i) => e(i) && !(i instanceof RegExp) && !(i instanceof Error) && !(i instanceof Date), n = (i, o, a, u = /* @__PURE__ */ new WeakMap()) => {
    if (a = {
      deep: !1,
      target: {},
      ...a
    }, u.has(i))
      return u.get(i);
    u.set(i, a.target);
    const { target: w } = a;
    delete a.target;
    const b = (O) => O.map((R) => r(R) ? n(R, o, a, u) : R);
    if (Array.isArray(i))
      return b(i);
    for (const [O, R] of Object.entries(i)) {
      const l = o(O, R, i);
      if (l === t)
        continue;
      let [m, S, { shouldRecurse: A = !0 } = {}] = l;
      m !== "__proto__" && (a.deep && A && r(S) && (S = Array.isArray(S) ? b(S) : n(S, o, a, u)), w[m] = S);
    }
    return w;
  };
  return We.exports = (i, o, a) => {
    if (!e(i))
      throw new TypeError(`Expected an object, got \`${i}\` (${typeof i})`);
    return n(i, o, a);
  }, We.exports.mapObjectSkip = t, We.exports;
}
var tt = function() {
  return tt = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, tt.apply(this, arguments);
};
function yi(e) {
  return e.toLowerCase();
}
var hi = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], mi = /[^A-Z0-9]+/gi;
function gi(e, t) {
  t === void 0 && (t = {});
  for (var r = t.splitRegexp, n = r === void 0 ? hi : r, i = t.stripRegexp, o = i === void 0 ? mi : i, a = t.transform, u = a === void 0 ? yi : a, w = t.delimiter, b = w === void 0 ? " " : w, O = sr(sr(e, n, "$1\0$2"), o, "\0"), R = 0, l = O.length; O.charAt(R) === "\0"; )
    R++;
  for (; O.charAt(l - 1) === "\0"; )
    l--;
  return O.slice(R, l).split("\0").map(u).join(b);
}
function sr(e, t, r) {
  return t instanceof RegExp ? e.replace(t, r) : t.reduce(function(n, i) {
    return n.replace(i, r);
  }, e);
}
function vi(e, t) {
  return t === void 0 && (t = {}), gi(e, tt({ delimiter: "." }, t));
}
function Ei(e, t) {
  return t === void 0 && (t = {}), vi(e, tt({ delimiter: "_" }, t));
}
const Si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: Ei
}, Symbol.toStringTag, { value: "Module" })), _i = /* @__PURE__ */ fi(Si);
var pt, or;
function bi() {
  if (or) return pt;
  or = 1;
  const e = pi(), { snakeCase: t } = _i, r = {}.constructor;
  pt = function(o, a) {
    if (Array.isArray(o)) {
      if (o.some((u) => u.constructor !== r))
        throw new Error("obj must be array of plain objects");
    } else if (o.constructor !== r)
      throw new Error("obj must be an plain object");
    return a = Object.assign({ deep: !0, exclude: [], parsingOptions: {} }, a), e(o, function(u, w) {
      return [
        n(a.exclude, u) ? u : t(u, a.parsingOptions),
        w,
        i(u, w, a)
      ];
    }, a);
  };
  function n(o, a) {
    return o.some(function(u) {
      return typeof u == "string" ? u === a : u.test(a);
    });
  }
  function i(o, a, u) {
    return u.shouldRecurse ? { shouldRecurse: u.shouldRecurse(o, a) } : void 0;
  }
  return pt;
}
var Ai = bi();
const G = /* @__PURE__ */ di(Ai);
function Ii(e) {
  return new RegExp("(^|:)//").test(e);
}
const Ti = (e) => e.replace(/\/$/, ""), Ri = (e) => e.replace(/^\//, "");
function ar(e, t) {
  return e ? t ? Ii(t) ? t : (e = Ti(e), t = Ri(t), `${e}/${t}`) : e : t || "";
}
const Pi = (e, t) => {
  try {
    const r = e.match(/<?([^>]*)>(.*)/);
    if (r) {
      const n = r[1], i = r[2].split(";"), o = new URL(n, t || window.location.href), a = Object.fromEntries(o.searchParams);
      let u = { url: n };
      const w = i.reduce((b, O) => {
        const R = O.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
        if (R) {
          const l = R[1], m = R[2];
          return b[l] = m, b;
        } else
          return b;
      }, {});
      return u = { ...a, ...u, ...w }, u;
    }
    return null;
  } catch (r) {
    return console.error("parseLinkInternal", r), null;
  }
}, wi = (e, t) => (t.rel.split(/\s+/).forEach((r) => {
  e[r] = { ...t, rel: r };
}), e), Oi = (e) => !!e && "rel" in e && "url" in e, Ci = (e, t) => !e || e.length > 2e3 ? null : e.split(/,\s*</).map((r) => Pi(r, t)).filter(Oi).reduce(wi, {}), qi = (e) => {
  let t = {};
  return e.has("Link") && (t = Ci(e.get("Link")) || {}), t;
}, Di = (e, t) => {
  var i, o;
  const r = { data: t };
  if (e === void 0)
    return r;
  const n = qi(e);
  return r.after = (i = n == null ? void 0 : n.after) == null ? void 0 : i.after, r.before = (o = n == null ? void 0 : n.before) == null ? void 0 : o.before, r;
}, $r = (e) => ({
  /**
   * Fetches all available Events
   */
  getEvents: e.query({
    query: (t) => ({
      url: "events",
      params: t
    }),
    providesTags: (t) => t ? [...t.data.map(({ id: r }) => ({ type: D.Event, id: r })), { type: D.Event, id: "PARTIAL-LIST" }] : [{ type: D.Event, id: "PARTIAL-LIST" }],
    transformResponse: (t, r) => {
      var n;
      return Di((n = r == null ? void 0 : r.response) == null ? void 0 : n.headers, t);
    }
  }),
  // Todo(r.floren): We could provide a query here that already spits out event instances based on the RRULE without using the instances endpoint
  // Along these lines
  // getEventsInstanced: builder.query<
  //   Array<EventInstance>,
  //   CursorPaginationParams & TimeRangeQueryParams & EventQueryParams
  // >({
  //   query: (params) => ({
  //     url: 'events',
  //     params: params,
  //   }),
  //   providesTags: (result) =>
  //     result
  //       ? [...result.map(({ id }) => ({ type: 'EventInstance' as const, id: id })), { type: 'EventInstance', id: 'PARTIAL-LIST' }]
  //       : [{ type: 'Room', id: 'PARTIAL-LIST' }],
  //   transformResponse: (response: ApiResponse<Event>): Event => {
  //     resolve rrules here add diffs from exceptions
  //     return camelcaseKeysDeep(response);
  //   },
  // }),
  /**
   * Create new event
   */
  createEvent: e.mutation({
    query: ({ ...t }) => ({
      url: "events",
      method: "POST",
      body: G(t, { deep: !0 })
    }),
    invalidatesTags: [{ type: D.Event, id: "PARTIAL-LIST" }]
  }),
  /**
   * Delete an event
   */
  deleteEvent: e.mutation({
    query: (t) => ({
      url: `events/${t}`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, n) => [{ type: D.Event, id: n }]
  }),
  /**
   * Create new event exception
   */
  createEventException: e.mutation({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/instances`,
      method: "POST",
      body: G(r)
    }),
    invalidatesTags: [{ type: D.Event, id: "PARTIAL-LIST" }]
  }),
  /**
   * Update an event
   */
  updateEvent: e.mutation({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}`,
      method: "PATCH",
      body: G(r, { deep: !0 })
    }),
    invalidatesTags: (t, r, { eventId: n }) => [{ type: D.Event, id: n }]
  }),
  /**
   * Reschedule all following events based on the from argument
   */
  rescheduleEvent: e.mutation({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/reschedule`,
      method: "POST",
      body: G(r)
    }),
    invalidatesTags: (t, r, { eventId: n }) => [{ type: D.Event, id: n }]
  }),
  /**
   * Used to get a single event
   */
  getEvent: e.query({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}`,
      params: r
    }),
    providesTags: (t) => t ? [{ type: D.Event, id: t.id }] : []
  }),
  /**
   * Used to resolve the instances on the server. Use at last resort
   */
  getEventInstances: e.query({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/instances`,
      params: r
    }),
    providesTags: (t) => t ? [
      ...t.map(({ id: r }) => ({ type: D.EventInstance, id: r })),
      { type: D.EventInstance, id: "PARTIAL-LIST" }
    ] : [{ type: D.EventInstance, id: "PARTIAL-LIST" }]
  }),
  /**
   * Get a single event instance based on eventId and instanceId
   */
  getEventInstance: e.query({
    query: ({ eventId: t, instanceId: r, ...n }) => ({
      url: `events/${t}/instances/${r}`,
      params: n
    }),
    providesTags: (t) => t ? [{ type: D.EventInstance, id: t.id }] : []
  }),
  /**
   * Update an event instance based on eventId and InstanceId
   */
  updateEventInstance: e.mutation({
    query: ({ eventId: t, instanceId: r, ...n }) => ({
      url: `events/${t}/instances/${r}`,
      method: "PATCH",
      body: n
    }),
    invalidatesTags: (t, r, { eventId: n, instanceId: i }) => [
      { type: D.EventInstance, id: i },
      { type: D.Event, id: n }
    ]
  }),
  /**
   * Get invites for an specific Event
   */
  getEventInvites: e.query({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/invites`,
      params: r
    }),
    providesTags: (t) => t ? [
      ...t.map(({ profile: r }) => ({
        type: D.EventInvite,
        id: "id" in r ? r.id : r.email
      })),
      { type: D.EventInvite, id: "PARTIAL-LIST" }
    ] : [{ type: D.EventInvite, id: "PARTIAL-LIST" }]
  }),
  /**
   * Create an invite to an event for an specific user
   */
  createEventInvite: e.mutation({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/invites`,
      method: "POST",
      body: G(r)
    }),
    invalidatesTags: () => [{ type: D.EventInvite, id: "PARTIAL-LIST" }]
  }),
  /**
   * Create an invite to an event for an specific user
   */
  updateEventInvite: e.mutation({
    query: ({ eventId: t, userId: r, ...n }) => ({
      url: `events/${t}/invites/${r}`,
      method: "PATCH",
      body: G(n)
    }),
    invalidatesTags: (t, r, { userId: n }) => [{ type: D.EventInvite, id: n }]
  }),
  /**
   * Delete/revoke an invite to an event for a specified user email
   */
  revokeEventUserInviteByEmail: e.mutation({
    query: ({ eventId: t, ...r }) => ({
      url: `events/${t}/invites/email`,
      method: "DELETE",
      body: G(r)
    }),
    invalidatesTags: () => [{ type: D.EventInvite, id: "PARTIAL-LIST" }]
  }),
  /**
   * Delete/revoke an invite to an event for a specified user id
   */
  revokeEventUserInvite: e.mutation({
    query: ({ eventId: t, userId: r }) => ({
      url: `events/${t}/invites/${r}`,
      method: "DELETE"
    }),
    invalidatesTags: () => [{ type: D.EventInvite, id: "PARTIAL-LIST" }]
  }),
  /**
   * Accept an event invite for the current user to the specified event
   */
  acceptEventInvite: e.mutation({
    query: ({ eventId: t }) => ({
      url: `events/${t}/invite`,
      method: "PATCH"
    }),
    invalidatesTags: (t, r, { eventId: n }) => [{ type: D.Event, id: n }]
  }),
  /**
   * Accept an event invite for the current user to the specified event
   */
  declineEventInvite: e.mutation({
    query: ({ eventId: t }) => ({
      url: `events/${t}/invite`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, { eventId: n }) => [
      { type: D.Event, id: n },
      { type: D.EventInvite, id: n }
    ]
  }),
  /**
   * Create a shared folder for event
   * Possibly needs the body changed or no body at all
   */
  createEventSharedFolder: e.mutation({
    query: ({ eventId: t }) => ({
      url: `events/${t}/shared_folder`,
      method: "PUT"
    }),
    invalidatesTags: (t, r, { eventId: n }) => [{ type: D.Event, id: n }]
  }),
  /**
   * Delete shared folder info
   */
  deleteEventSharedFolder: e.mutation({
    query: ({ eventId: t, forceDeletion: r }) => ({
      url: `events/${t}/shared_folder?force_delete_reference_if_shared_folder_deletion_fails=${r}`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, { eventId: n }) => [{ type: D.Event, id: n }]
  })
}), xr = (e) => ({
  getRooms: e.query({
    query: (t) => ({ url: "rooms", params: t }),
    providesTags: (t) => t ? [...t.map(({ id: r }) => ({ type: D.Room, id: r })), { type: D.Room, id: "PARTIAL-LIST" }] : [{ type: D.Room, id: "PARTIAL-LIST" }]
  }),
  getRoom: e.query({
    query: (t) => `rooms/${t}`,
    providesTags: (t) => t ? [{ type: D.Room, id: t.id }] : []
  }),
  getRoomTariff: e.query({
    query: (t) => `rooms/${t}/tariff`,
    providesTags: (t) => t ? [{ type: D.Tariff, id: t.id }] : []
  }),
  getRoomEventInfo: e.query({
    query: ({ id: t, inviteCode: r }) => {
      const n = {
        url: `rooms/${t}/event`
      };
      return r && (n.headers = {
        authorization: `InviteCode ${r}`
      }), n;
    },
    providesTags: (t) => t ? [{ type: D.Room, id: t.id }] : []
  }),
  createRoom: e.mutation({
    query: (t) => ({
      url: "rooms",
      method: "POST",
      body: G(t)
    }),
    invalidatesTags: [{ type: D.Room, id: "PARTIAL-LIST" }]
  }),
  updateRoom: e.mutation({
    query: ({ id: t, ...r }) => ({
      url: `rooms/${t}`,
      method: "PATCH",
      body: G(r)
    }),
    invalidatesTags: (t, r, { id: n }) => [
      { type: D.Room, id: n },
      { type: D.Room, id: "PARTIAL-LIST" }
    ]
  }),
  deleteRoom: e.mutation({
    query: (t) => ({
      url: `rooms/${t}`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, n) => [
      { type: D.Room, id: n },
      { type: D.Room, id: "PARTIAL-LIST" }
    ]
  }),
  /**
   * Create or update a SIP-Configuration for a specific room
   */
  updateRoomSipConfig: e.mutation({
    query: ({ id: t, ...r }) => ({
      url: `rooms/${t}/sip`,
      method: "PUT",
      body: G(r)
    }),
    invalidatesTags: (t, r, { id: n }) => [
      { type: D.Room, id: n },
      { type: D.Room, id: "PARTIAL-LIST" }
    ]
  }),
  /**
   * Create an inviteId for a room
   */
  createRoomInvite: e.mutation({
    query: ({ id: t, ...r }) => ({
      url: `rooms/${t}/invites`,
      method: "POST",
      body: G(r)
    }),
    invalidatesTags: (t, r, { id: n }) => [
      { type: D.RoomInvite, id: n },
      { type: D.RoomInvite, id: "PARTIAL-LIST" }
    ]
  }),
  /**
   * get all invites for a room
   */
  getRoomInvites: e.query({
    query: ({ roomId: t }) => `rooms/${t}/invites`,
    providesTags: (t) => t ? [
      ...t.map(({ inviteCode: r }) => ({ type: D.RoomInvite, id: r })),
      { type: D.RoomInvite, id: "PARTIAL-LIST" }
    ] : [{ type: D.RoomInvite, id: "PARTIAL-LIST" }]
  }),
  /*
   * get all assets for a room
   */
  getRoomAssets: e.query({
    query: (t) => ({ url: `rooms/${t}/assets` }),
    providesTags: (t) => t ? [...t.map(({ id: r }) => ({ type: D.Asset, id: r })), { type: D.Asset, id: "PARTIAL-LIST" }] : [{ type: D.Asset, id: "PARTIAL-LIST" }]
  }),
  /*
   * delete an asset from room
   */
  deleteRoomAsset: e.mutation({
    query: ({ roomId: t, assetId: r }) => ({ url: `rooms/${t}/assets/${r}`, method: "DELETE" }),
    invalidatesTags: (t, r, { assetId: n }) => [
      { type: D.Asset, assetId: n },
      { type: D.Asset, assetId: "PARTIAL-LIST" },
      // need for re-calcualtion of the used storage
      { type: D.User, id: "ME" }
    ]
  }),
  /**
   * Get all streaming targets for a room
   * IMPORTANT: All streaming-relevant data can be retrieved from the `Event` object, of
   *            the `getEvent` response
   */
  getStreamingTargets: e.query({
    query: (t) => ({ url: `rooms/${t}/streaming_targets` }),
    providesTags: (t) => t ? [
      ...t.map(({ id: r }) => ({ type: D.StreamingTargets, id: r })),
      { type: D.StreamingTargets, id: "PARTIAL-LIST" }
    ] : [{ type: D.StreamingTargets, id: "PARTIAL-LIST" }]
  }),
  /**
   * Add new streaming targets to a room. Currently accepts only one target per request.
   * IMPORTANT: Streaming targets can be modified via `updateEvent` or `createEvent` as well.
   */
  addStreamingTargets: e.mutation({
    query: ({ roomId: t, target: r }) => ({
      url: `rooms/${t}/streaming_targets`,
      method: "POST",
      body: G(r)
    }),
    invalidatesTags: [{ type: D.StreamingTargets, id: "PARTIAL-LIST" }]
  }),
  /**
   * Get specific streaming target
   * IMPORTANT: All streaming-relevant data can be retrieved from the `Event` object, of
   *            the `getEvent` response
   */
  getStreamingTarget: e.query({
    query: ({ roomId: t, targetId: r }) => ({
      url: `rooms/${t}/streaming_targets/${r}`
    }),
    providesTags: (t) => t ? [{ type: D.StreamingTargets, id: t.id }] : []
  }),
  /**
   * Update specific streaming target
   * IMPORTANT: Streaming targets can be modified via `updateEvent` or `createEvent` as well.*
   */
  updateStreamingTarget: e.mutation({
    query: ({ roomId: t, targetId: r, ...n }) => ({
      url: `rooms/${t}/streaming_targets/${r}`,
      method: "PATCH",
      body: G(n)
    }),
    invalidatesTags: (t, r, { targetId: n }) => [
      { type: D.StreamingTargets, id: n },
      { type: D.StreamingTargets, id: "PARTIAL-LIST" }
    ]
  }),
  /**
   * Delete specific streaming target
   * IMPORTANT: Streaming targets can be modified via `updateEvent` or `createEvent` as well.
   */
  deleteStreamingTarget: e.mutation({
    query: ({ roomId: t, targetId: r }) => ({
      url: `rooms/${t}/streaming_targets/${r}`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, { targetId: n }) => [
      { type: D.StreamingTargets, id: n },
      { type: D.StreamingTargets, id: "PARTIAL-LIST" }
    ]
  })
}), Fr = (e) => ({
  getMe: e.query({
    query: () => "users/me",
    providesTags: [{ type: D.User, id: "ME" }]
  }),
  updateMe: e.mutation({
    query: (t) => ({
      url: "users/me",
      method: "PATCH",
      body: G(t)
    }),
    invalidatesTags: [{ type: D.User, id: "ME" }]
  }),
  getMeTariff: e.query({
    query: () => "users/me/tariff",
    providesTags: (t) => t ? [{ type: D.Tariff, id: t.id }] : []
  }),
  getUser: e.query({
    query: (t) => `users/${t}`,
    providesTags: (t) => t ? [{ type: D.User, id: t.id }] : []
  }),
  getUserOwnedAssets: e.query({
    query: () => "users/me/assets",
    providesTags: (t) => t != null && t.ownedAssets ? [...t.ownedAssets.map(({ id: r }) => ({ type: D.Asset, id: r })), { type: D.Asset, id: "PARTIAL-LIST" }] : [{ type: D.Asset, id: "PARTIAL-LIST" }]
  }),
  // TODO(r.floren) we could implement a debounce based ratelimit here I guess as a safeguard, else this should realisticly
  // be included in the caller, else this would create a bad UX with jittering all over the place.
  findUsers: e.query({
    query: (t) => ({
      url: "users/find",
      params: t
    }),
    providesTags: (t) => t ? [
      ...t.map(({ email: r }) => ({ type: D.FindUser, id: r })),
      { type: D.FindUser, id: "PARTIAL-LIST" }
    ] : [{ type: D.FindUser, id: "PARTIAL-LIST" }]
  }),
  /**
   * mark an event as favorite
   */
  markFavoriteEvent: e.mutation({
    query: (t) => ({
      url: `users/me/event_favorites/${t}`,
      method: "PUT"
    }),
    invalidatesTags: (t, r, n) => [
      { type: D.User, id: "ME" },
      { type: D.Event, id: n },
      { type: D.Event, id: "PARTIAL-LIST" }
    ]
  }),
  /**
   * unmark a favorite event
   */
  unmarkFavoriteEvent: e.mutation({
    query: (t) => ({
      url: `users/me/event_favorites/${t}`,
      method: "DELETE"
    }),
    invalidatesTags: (t, r, n) => [
      { type: D.User, id: "ME" },
      { type: D.Event, id: n }
    ]
  })
}), ls = (e) => Gn({
  baseQuery: e,
  tagTypes: kr,
  endpoints: (t) => ({
    ...xr(t),
    ...Fr(t),
    ...$r(t)
  })
}), ds = (e) => ui({
  baseQuery: e,
  tagTypes: kr,
  endpoints: (t) => ({
    ...xr(t),
    ...Fr(t),
    ...$r(t)
  })
}), zr = (e) => typeof e == "object" && e !== null, cr = (e) => zr(e) && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), Li = Symbol("mapObjectSkip"), It = (e, t, r, n = /* @__PURE__ */ new WeakMap()) => {
  if (r = {
    deep: !1,
    target: {},
    ...r
  }, n.has(e))
    return n.get(e);
  n.set(e, r.target);
  const { target: i } = r;
  delete r.target;
  const o = (a) => a.map((u) => cr(u) ? It(u, t, r, n) : u);
  if (Array.isArray(e))
    return o(e);
  for (const [a, u] of Object.entries(e)) {
    const w = t(a, u, e);
    if (w === Li)
      continue;
    let [b, O, { shouldRecurse: R = !0 } = {}] = w;
    b !== "__proto__" && (r.deep && R && cr(O) && (O = Array.isArray(O) ? o(O) : It(O, t, r, n)), i[b] = O);
  }
  return i;
};
function ur(e, t, r) {
  if (!zr(e))
    throw new TypeError(`Expected an object, got \`${e}\` (${typeof e})`);
  return It(e, t, r);
}
const Ni = /[\p{Lu}]/u, Qi = /[\p{Ll}]/u, lr = /^[\p{Lu}](?![\p{Lu}])/gu, jr = /([\p{Alpha}\p{N}_]|$)/u, Nt = /[_.\- ]+/, Mi = new RegExp("^" + Nt.source), dr = new RegExp(Nt.source + jr.source, "gu"), fr = new RegExp("\\d+" + jr.source, "gu"), ki = (e, t, r, n) => {
  let i = !1, o = !1, a = !1, u = !1;
  for (let w = 0; w < e.length; w++) {
    const b = e[w];
    u = w > 2 ? e[w - 3] === "-" : !0, i && Ni.test(b) ? (e = e.slice(0, w) + "-" + e.slice(w), i = !1, a = o, o = !0, w++) : o && a && Qi.test(b) && (!u || n) ? (e = e.slice(0, w - 1) + "-" + e.slice(w - 1), a = o, o = !1, i = !0) : (i = t(b) === b && r(b) !== b, a = o, o = r(b) === b && t(b) !== b);
  }
  return e;
}, $i = (e, t) => (lr.lastIndex = 0, e.replaceAll(lr, (r) => t(r))), xi = (e, t) => (dr.lastIndex = 0, fr.lastIndex = 0, e.replaceAll(fr, (r, n, i) => ["_", "-"].includes(e.charAt(i + r.length)) ? r : t(r)).replaceAll(dr, (r, n) => t(n)));
function Fi(e, t) {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(e) ? e = e.map((o) => o.trim()).filter((o) => o.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const r = t.locale === !1 ? (o) => o.toLowerCase() : (o) => o.toLocaleLowerCase(t.locale), n = t.locale === !1 ? (o) => o.toUpperCase() : (o) => o.toLocaleUpperCase(t.locale);
  return e.length === 1 ? Nt.test(e) ? "" : t.pascalCase ? n(e) : r(e) : (e !== r(e) && (e = ki(e, r, n, t.preserveConsecutiveUppercase)), e = e.replace(Mi, ""), e = t.preserveConsecutiveUppercase ? $i(e, r) : r(e), t.pascalCase && (e = n(e.charAt(0)) + e.slice(1)), xi(e, n));
}
class zi extends Map {
  constructor(t = {}) {
    if (super(), !(t.maxSize && t.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof t.maxAge == "number" && t.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = t.maxSize, this.maxAge = t.maxAge || Number.POSITIVE_INFINITY, this.onEviction = t.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(t) {
    if (typeof this.onEviction == "function")
      for (const [r, n] of t)
        this.onEviction(r, n.value);
  }
  _deleteIfExpired(t, r) {
    return typeof r.expiry == "number" && r.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(t, r.value), this.delete(t)) : !1;
  }
  _getOrDeleteIfExpired(t, r) {
    if (this._deleteIfExpired(t, r) === !1)
      return r.value;
  }
  _getItemValue(t, r) {
    return r.expiry ? this._getOrDeleteIfExpired(t, r) : r.value;
  }
  _peek(t, r) {
    const n = r.get(t);
    return this._getItemValue(t, n);
  }
  _set(t, r) {
    this.cache.set(t, r), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(t, r) {
    this.oldCache.delete(t), this._set(t, r);
  }
  *_entriesAscending() {
    for (const t of this.oldCache) {
      const [r, n] = t;
      this.cache.has(r) || this._deleteIfExpired(r, n) === !1 && (yield t);
    }
    for (const t of this.cache) {
      const [r, n] = t;
      this._deleteIfExpired(r, n) === !1 && (yield t);
    }
  }
  get(t) {
    if (this.cache.has(t)) {
      const r = this.cache.get(t);
      return this._getItemValue(t, r);
    }
    if (this.oldCache.has(t)) {
      const r = this.oldCache.get(t);
      if (this._deleteIfExpired(t, r) === !1)
        return this._moveToRecent(t, r), r.value;
    }
  }
  set(t, r, { maxAge: n = this.maxAge } = {}) {
    const i = typeof n == "number" && n !== Number.POSITIVE_INFINITY ? Date.now() + n : void 0;
    return this.cache.has(t) ? this.cache.set(t, {
      value: r,
      expiry: i
    }) : this._set(t, { value: r, expiry: i }), this;
  }
  has(t) {
    return this.cache.has(t) ? !this._deleteIfExpired(t, this.cache.get(t)) : this.oldCache.has(t) ? !this._deleteIfExpired(t, this.oldCache.get(t)) : !1;
  }
  peek(t) {
    if (this.cache.has(t))
      return this._peek(t, this.cache);
    if (this.oldCache.has(t))
      return this._peek(t, this.oldCache);
  }
  delete(t) {
    const r = this.cache.delete(t);
    return r && this._size--, this.oldCache.delete(t) || r;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(t) {
    if (!(t && t > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const r = [...this._entriesAscending()], n = r.length - t;
    n < 0 ? (this.cache = new Map(r), this.oldCache = /* @__PURE__ */ new Map(), this._size = r.length) : (n > 0 && this._emitEvictions(r.slice(0, n)), this.oldCache = new Map(r.slice(n)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = t;
  }
  *keys() {
    for (const [t] of this)
      yield t;
  }
  *values() {
    for (const [, t] of this)
      yield t;
  }
  *[Symbol.iterator]() {
    for (const t of this.cache) {
      const [r, n] = t;
      this._deleteIfExpired(r, n) === !1 && (yield [r, n.value]);
    }
    for (const t of this.oldCache) {
      const [r, n] = t;
      this.cache.has(r) || this._deleteIfExpired(r, n) === !1 && (yield [r, n.value]);
    }
  }
  *entriesDescending() {
    let t = [...this.cache];
    for (let r = t.length - 1; r >= 0; --r) {
      const n = t[r], [i, o] = n;
      this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
    t = [...this.oldCache];
    for (let r = t.length - 1; r >= 0; --r) {
      const n = t[r], [i, o] = n;
      this.cache.has(i) || this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
  }
  *entriesAscending() {
    for (const [t, r] of this._entriesAscending())
      yield [t, r.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let t = 0;
    for (const r of this.oldCache.keys())
      this.cache.has(r) || t++;
    return Math.min(this._size + t, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(t, r = this) {
    for (const [n, i] of this.entriesAscending())
      t.call(r, i, n, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
const ji = (e, t) => e.some((r) => typeof r == "string" ? r === t : (r.lastIndex = 0, r.test(t))), yt = new zi({ maxSize: 1e5 }), pr = (e) => typeof e == "object" && e !== null && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), yr = (e, t = {}) => {
  if (!pr(e))
    return e;
  const {
    exclude: r,
    pascalCase: n = !1,
    stopPaths: i,
    deep: o = !1,
    preserveConsecutiveUppercase: a = !1
  } = t, u = new Set(i), w = (b) => (O, R) => {
    if (o && pr(R)) {
      const l = b === void 0 ? O : `${b}.${O}`;
      u.has(l) || (R = ur(R, w(l)));
    }
    if (!(r && ji(r, O))) {
      const l = n ? `${O}_` : O;
      if (yt.has(l))
        O = yt.get(l);
      else {
        const m = Fi(O, { pascalCase: n, locale: !1, preserveConsecutiveUppercase: a });
        O.length < 100 && yt.set(l, m), O = m;
      }
    }
    return [O, R];
  };
  return ur(e, w(void 0));
};
function Ui(e, t) {
  return Array.isArray(e) ? Object.keys(e).map((r) => yr(e[r], t)) : yr(e, t);
}
function Vi(e) {
  return Ui(e, { deep: !0 });
}
const Ki = (e, t) => fetch(e, t), Hi = (e) => e.status >= 200 && e.status <= 299, Wi = (e) => {
  var t, r;
  return (r = (t = e.get("content-type")) == null ? void 0 : t.trim()) == null ? void 0 : r.startsWith("application/json");
};
function Bi(e) {
  return De(e);
}
function Ji(e) {
  return e === void 0 || e instanceof Headers ? e : Bi(e) ? Ur(e) : e.filter((r) => r.length === 2 && r[1] !== void 0).map((r) => r);
}
function Ur(e) {
  const t = { ...e };
  for (const [r, n] of Object.entries(t))
    typeof n > "u" && delete t[r];
  return t;
}
function fs({
  baseUrl: e,
  prepareHeaders: t = (a) => a,
  transformJsonResponse: r = Vi,
  fetchFn: n = Ki,
  paramsSerializer: i,
  ...o
} = {}) {
  const a = async (u, w) => {
    if (typeof w == "function")
      return w(u);
    if (w === "text")
      return u.text();
    if (w === "json") {
      const b = await u.text();
      return b.length ? r(JSON.parse(b)) : null;
    }
  };
  return async (u, w) => {
    const { signal: b, getState: O, extra: R, endpoint: l, forced: m, type: S } = w, A = typeof u == "string" ? { url: u } : u, {
      method: I = "GET",
      headers: v = new Headers({}),
      body: C = void 0,
      params: p = void 0,
      responseHandler: s = "json",
      validateStatus: f = Hi,
      ...P
    } = A;
    let { url: _ } = A;
    const T = {
      ...o,
      method: I,
      signal: b,
      body: C,
      ...P
    };
    T.headers = await t(new Headers(Ji(v)), {
      getState: O,
      extra: R,
      endpoint: l,
      forced: m,
      type: S
    });
    const g = (L) => typeof L == "object" && (De(L) || Array.isArray(L) || L !== null && typeof L.toJSON == "function");
    if (!T.headers.has("content-type") && g(C) && T.headers.set("content-type", "application/json"), C && Wi(T.headers) && (T.body = JSON.stringify(C)), p !== void 0 && Object.keys(p).length > 0) {
      const L = ~_.indexOf("?") ? "&" : "?", M = i ? i(p) : new URLSearchParams(G(Ur(p)));
      _ += L + M;
    }
    typeof e == "function" ? _ = ar(await e({ getState: O, extra: R, endpoint: l, forced: m, type: S }), _) : _ = ar(e, _);
    const d = new Request(_, T), h = { request: d.clone() };
    let y;
    try {
      y = await n(d);
    } catch (L) {
      return { error: { status: "FETCH_ERROR", error: String(L) }, meta: h };
    }
    const E = y.clone();
    h.response = E;
    let q, N = "";
    try {
      let L;
      if (await Promise.all([
        a(y, s).then(
          (M) => q = M,
          (M) => L = M
        ),
        //FIXME: See if we can remove this as we probably do not need to support node-fetch.
        // The next Nodejs version does support fetch natively, we should check if this is the
        // case with the native fetch as well
        //
        // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
        // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
        E.text().then(
          (M) => N = M,
          () => {
          }
        )
      ]), L)
        throw L;
    } catch (L) {
      return {
        error: {
          status: "PARSING_ERROR",
          originalStatus: y.status,
          data: N,
          error: String(L)
        },
        meta: h
      };
    }
    return f(y, q) ? {
      data: q,
      meta: h
    } : {
      error: {
        status: y.status,
        data: q
      },
      meta: h
    };
  };
}
var Gi = /* @__PURE__ */ ((e) => (e.Automod = "automod", e.Breakout = "breakout", e.Chat = "chat", e.Core = "core", e.Echo = "echo", e.Integration = "integration", e.LegalVote = "legalVote", e.Media = "media", e.Moderation = "moderation", e.Polls = "polls", e.MeetingNotes = "meetingNotes", e.MeetingReport = "meetingReport", e.Recording = "recording", e.RecordingService = "recordingService", e.Timer = "timer", e.Whiteboard = "whiteboard", e.SubroomAudio = "subroomAudio", e.TrainingParticipationReport = "trainingParticipationReport", e))(Gi || {}), Yi = /* @__PURE__ */ ((e) => (e.Provider = "provider", e.BuiltIn = "builtin", e.Custom = "custom", e))(Yi || {}), Zi = /* @__PURE__ */ ((e) => (e.Active = "active", e.Inactive = "inactive", e.Paused = "paused", e.Unavailable = "unavailable", e.Error = "error", e))(Zi || {}), Xi = /* @__PURE__ */ ((e) => (e.Recording = "recording", e.Livestream = "livestream", e))(Xi || {}), es = /* @__PURE__ */ ((e) => (e.USER = "user", e.MODERATOR = "moderator", e))(es || {}), ts = /* @__PURE__ */ ((e) => (e.Cancelled = "cancelled", e.Ok = "ok", e))(ts || {}), rs = /* @__PURE__ */ ((e) => (e.Single = "single", e.Recurring = "recurring", e.Instance = "instance", e.Exception = "exception", e))(rs || {});
const ps = (e) => e.type === "exception", ys = (e) => ns(e) || is(e) || ss(e), ns = (e) => e.type === "recurring", hs = (e) => e.type === "instance", is = (e) => e.isTimeIndependent === !1 && e.type === "single", ss = (e) => e.isTimeIndependent === !0 && e.type === "single";
export {
  Gi as BackendModules,
  ts as EventStatus,
  rs as EventType,
  li as InviteStatus,
  Yi as PlatformKind,
  Xi as StreamingKind,
  Zi as StreamingStatus,
  D as Tag,
  es as UserRole,
  ls as createOpenTalkApi,
  ds as createOpenTalkApiWithReactHooks,
  fs as fetchQuery,
  ys as isEvent,
  ps as isEventException,
  hs as isEventInstance,
  ns as isRecurringEvent,
  is as isSingleEvent,
  ss as isTimelessEvent
};
//# sourceMappingURL=main.js.map
